/* NgRx */
import { createAction, props } from '@ngrx/store';
import { ProjectCalendar } from 'src/app/shared/models/billing-settings';

/******** CLEAR STATE ***********/
const CLEAR_STATE = '[projects] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** CLEAR CHANGE ORDER REQUEST WITH ID ***********/
const CLEAR_CHANGE_ORDER_REQUEST_WITH_ID = '[projects] clear change order request with id';
export const ClearChangeOrdersRequestWithId = createAction(CLEAR_CHANGE_ORDER_REQUEST_WITH_ID);

/******** CLEAR CHANGE IN WORK REQUEST WITH ID ***********/
const CLEAR_CHANGE_IN_WORK_REQUEST_WITH_ID = '[projects] clear change in work request with id';
export const ClearChangeInWorkRequestWithId = createAction(CLEAR_CHANGE_IN_WORK_REQUEST_WITH_ID);

/******** CLEAR SUBMITTALS ITEM DETAILS WITH ID ***********/
const CLEAR_SUBMITTALS_ITEM_DETAILS_WITH_ID = '[projects] clear submittals item details with id';
export const ClearSubmittalsItemDetailsWithId = createAction(CLEAR_SUBMITTALS_ITEM_DETAILS_WITH_ID);

/******** CLEAR RFI ITEM DETAILS WITH ID ***********/
const CLEAR_RFI_ITEM_DETAILS_WITH_ID = '[projects] clear rfi item details with id';
export const ClearRFIItemDetailsWithId = createAction(CLEAR_RFI_ITEM_DETAILS_WITH_ID);

/******** SET CURRENT LOCATION ***********/
const SET_CURRENT_LOCATION = '[projects] set current location';
export const SetCurrentLocation = createAction(SET_CURRENT_LOCATION, props<any>());

/******** SET QP FOR MAP ***********/
const SET_QP_FOR_MAP = '[projects] set qp for map';
export const SetQPForMap = createAction(SET_QP_FOR_MAP, props<any>());

/********** [/projects]  ************/

/******** FETCH PROJECTS LIST ***********/
const FETCH_PROJECTS_LIST_REQUEST = '[projects] fetch projects list request';
export const FetchProjectsListRequest = createAction(FETCH_PROJECTS_LIST_REQUEST, props<any>());

const FETCH_PROJECTS_LIST_SUCCESS = '[projects] fetch projects list success';
export const FetchProjectsListSuccess = createAction(FETCH_PROJECTS_LIST_SUCCESS, props<any>());

const FETCH_PROJECTS_LIST_FAILURE = '[projects] fetch projects list failure';
export const FetchProjectsListFailure = createAction(FETCH_PROJECTS_LIST_FAILURE, props<any>());

/********** [/projects/:projectId?tab=sites]  ************/

/******** FETCH PROJECT DETAILS ***********/
const FETCH_PROJECT_DETAILS_REQUEST = '[projects] fetch project details request';
export const FetchProjectDetailsRequest = createAction(FETCH_PROJECT_DETAILS_REQUEST, props<any>());

const FETCH_PROJECT_DETAILS_SUCCESS = '[projects] fetch project details success';
export const FetchProjectDetailsSuccess = createAction(FETCH_PROJECT_DETAILS_SUCCESS, props<any>());

const FETCH_PROJECT_DETAILS_FAILURE = '[projects] fetch project details failure';
export const FetchProjectDetailsFailure = createAction(FETCH_PROJECT_DETAILS_FAILURE, props<any>());

/******** UPDATE PROJECT ***********/
const UPDATE_PROJECT_REQUEST = '[projects] update project request';
export const UpdateProjectRequest = createAction(UPDATE_PROJECT_REQUEST, props<any>());

const UPDATE_PROJECT_SUCCESS = '[projects] update project success';
export const UpdateProjectSuccess = createAction(UPDATE_PROJECT_SUCCESS, props<any>());

const UPDATE_PROJECT_FAILURE = '[projects] update project failure';
export const UpdateProjectFailure = createAction(UPDATE_PROJECT_FAILURE);

/******** FETCH PROJECT DOCUMENTS ***********/
const FETCH_PROJECT_DOCUMENTS_REQUEST = '[projects] fetch project documents request';
export const FetchProjectDocumentsRequest = createAction(FETCH_PROJECT_DOCUMENTS_REQUEST, props<any>());

const FETCH_PROJECT_DOCUMENTS_SUCCESS = '[projects] fetch project documents success';
export const FetchProjectDocumentsSuccess = createAction(FETCH_PROJECT_DOCUMENTS_SUCCESS, props<any>());

const FETCH_PROJECT_DOCUMENTS_FAILURE = '[projects] fetch project documents failure';
export const FetchProjectDocumentsFailure = createAction(FETCH_PROJECT_DOCUMENTS_FAILURE, props<any>());

/******** UPDATE PROJECT DOCUMENTS BREADCRUMBS ***********/
const UPDATE_PROJECT_DOCUMENTS_BREADCRUMBS = '[projects] update project documents breadcrumbs';
export const UpdateProjectDocumentsBreadcrumbs = createAction(
  UPDATE_PROJECT_DOCUMENTS_BREADCRUMBS,
  props<{ breadcrumbs: Array<{ id: string; name: string }>; currentRootId: string | null }>()
);

/******** CREATE FOLDER ***********/
const CREATE_FOLDER_REQUEST = '[projects] create folder request';
export const CreateFolderRequest = createAction(CREATE_FOLDER_REQUEST, props<any>());

const CREATE_FOLDER_SUCCESS = '[projects] create folder success';
export const CreateFolderSuccess = createAction(CREATE_FOLDER_SUCCESS, props<any>());

const CREATE_FOLDER_FAILURE = '[projects] create folder failure';
export const CreateFolderFailure = createAction(CREATE_FOLDER_FAILURE, props<any>());

/******** DELETE FOLDER ***********/
const DELETE_FOLDER_REQUEST = '[projects] delete folder request';
export const DeleteFolderRequest = createAction(DELETE_FOLDER_REQUEST, props<any>());

const DELETE_FOLDER_SUCCESS = '[projects] delete folder success';
export const DeleteFolderSuccess = createAction(DELETE_FOLDER_SUCCESS, props<any>());

const DELETE_FOLDER_FAILURE = '[projects] delete folder failure';
export const DeleteFolderFailure = createAction(DELETE_FOLDER_FAILURE, props<any>());

/******** UPDATE FOLDER NAME ***********/
const UPDATE_FOLDER_NAME_REQUEST = '[projects] update folder name request';
export const UpdateFolderNameRequest = createAction(UPDATE_FOLDER_NAME_REQUEST, props<any>());

const UPDATE_FOLDER_NAME_SUCCESS = '[projects] update folder name success';
export const UpdateFolderNameSuccess = createAction(UPDATE_FOLDER_NAME_SUCCESS, props<any>());

const UPDATE_FOLDER_NAME_FAILURE = '[projects] update folder name failure';
export const UpdateFolderNameFailure = createAction(UPDATE_FOLDER_NAME_FAILURE, props<any>());

/******** ADD DOCUMENT ***********/
const ADD_DOCUMENT_REQUEST = '[projects] add document request';
export const AddDocumentRequest = createAction(ADD_DOCUMENT_REQUEST, props<any>());

const ADD_DOCUMENT_SUCCESS = '[projects] add document success';
export const AddDocumentSuccess = createAction(ADD_DOCUMENT_SUCCESS, props<any>());

const ADD_DOCUMENT_FAILURE = '[projects] add document failure';
export const AddDocumentFailure = createAction(ADD_DOCUMENT_FAILURE, props<any>());

/******** DELETE DOCUMENT ***********/
const DELETE_DOCUMENT_REQUEST = '[projects] delete document request';
export const DeleteDocumentRequest = createAction(DELETE_DOCUMENT_REQUEST, props<any>());

const DELETE_DOCUMENT_SUCCESS = '[projects] delete document success';
export const DeleteDocumentSuccess = createAction(DELETE_DOCUMENT_SUCCESS, props<any>());

const DELETE_DOCUMENT_FAILURE = '[projects] delete document failure';
export const DeleteDocumentFailure = createAction(DELETE_DOCUMENT_FAILURE, props<any>());

/******** UPDATE DOCUMENT NAME ***********/
const UPDATE_DOCUMENT_NAME_REQUEST = '[projects] update document name request';
export const UpdateDocumentNameRequest = createAction(UPDATE_DOCUMENT_NAME_REQUEST, props<any>());

const UPDATE_DOCUMENT_NAME_SUCCESS = '[projects] update document name success';
export const UpdateDocumentNameSuccess = createAction(UPDATE_DOCUMENT_NAME_SUCCESS, props<any>());

const UPDATE_DOCUMENT_NAME_FAILURE = '[projects] update document name failure';
export const UpdateDocumentNameFailure = createAction(UPDATE_DOCUMENT_NAME_FAILURE, props<any>());

/******** FETCH SITE AND DAILY REPORTS SUMMARY ***********/
const FETCH_SITE_WISE_DAILY_REPORT_SUMMARY_REQUEST = '[projects] fetch site wise daily report summary request';
export const FetchSiteWiseDailyReportSummaryRequest = createAction(
  FETCH_SITE_WISE_DAILY_REPORT_SUMMARY_REQUEST,
  props<any>()
);

const FETCH_SITE_WISE_DAILY_REPORT_SUMMARY_SUCCESS = '[projects] fetch site wise daily report summary success';
export const FetchSiteWiseDailyReportSummarySuccess = createAction(
  FETCH_SITE_WISE_DAILY_REPORT_SUMMARY_SUCCESS,
  props<any>()
);

const FETCH_SITE_WISE_DAILY_REPORT_SUMMARY_FAILURE = '[projects] fetch site wise daily report summary failure';
export const FetchSiteWiseDailyReportSummaryFailure = createAction(FETCH_SITE_WISE_DAILY_REPORT_SUMMARY_FAILURE);

/******** FETCH PROJECT MEMBERS ***********/
const FETCH_PROJECT_MEMBERS_REQUEST = '[projects] fetch project members request';
export const FetchProjectMembersRequest = createAction(FETCH_PROJECT_MEMBERS_REQUEST, props<any>());

const FETCH_PROJECT_MEMBERS_SUCCESS = '[projects] fetch project members success';
export const FetchProjectMembersSuccess = createAction(FETCH_PROJECT_MEMBERS_SUCCESS, props<any>());

const FETCH_PROJECT_MEMBERS_FAILURE = '[projects] fetch project members failure';
export const FetchProjectMembersFailure = createAction(FETCH_PROJECT_MEMBERS_FAILURE);

/******** FETCH PROJECT ACCOUNTS ***********/
const FETCH_PROJECT_ACCOUNTS_REQUEST = '[projects] fetch project accounts request';
export const FetchProjectAccountsRequest = createAction(FETCH_PROJECT_ACCOUNTS_REQUEST, props<any>());

const FETCH_PROJECT_ACCOUNTS_SUCCESS = '[projects] fetch project accounts success';
export const FetchProjectAccountsSuccess = createAction(FETCH_PROJECT_ACCOUNTS_SUCCESS, props<any>());

const FETCH_PROJECT_ACCOUNTS_FAILURE = '[projects] fetch project accounts failure';
export const FetchProjectAccountsFailure = createAction(FETCH_PROJECT_ACCOUNTS_FAILURE);

/******** FETCH PROJECT INVITATIONS ***********/
const FETCH_PROJECT_INVITATIONS_REQUEST = '[projects] fetch project invitations request';
export const FetchProjectInvitationsRequest = createAction(FETCH_PROJECT_INVITATIONS_REQUEST, props<any>());

const FETCH_PROJECT_INVITATIONS_SUCCESS = '[projects] fetch project invitations success';
export const FetchProjectInvitationsSuccess = createAction(FETCH_PROJECT_INVITATIONS_SUCCESS, props<any>());

const FETCH_PROJECT_INVITATIONS_FAILURE = '[projects] fetch project invitations failure';
export const FetchProjectInvitationsFailure = createAction(FETCH_PROJECT_INVITATIONS_FAILURE);

/******** CREATE PROJECT INVITATION ***********/
const CREATE_PROJECT_INVITATION_REQUEST = '[projects] create project invitation request';
export const CreateProjectInvitationRequest = createAction(CREATE_PROJECT_INVITATION_REQUEST, props<any>());

const CREATE_PROJECT_INVITATION_SUCCESS = '[projects] create project invitation success';
export const CreateProjectInvitationSuccess = createAction(CREATE_PROJECT_INVITATION_SUCCESS, props<any>());

const CREATE_PROJECT_INVITATION_FAILURE = '[projects] create project invitation failure';
export const CreateProjectInvitationFailure = createAction(CREATE_PROJECT_INVITATION_FAILURE);

/******** FETCH PROJECT SITES FOR INVITATION ***********/
const FETCH_PROJECT_SITES_FOR_INVITATION_REQUEST = '[projects] fetch project sites for invitation request';
export const FetchProjectSitesForInvitationRequest = createAction(
  FETCH_PROJECT_SITES_FOR_INVITATION_REQUEST,
  props<any>()
);

const FETCH_PROJECT_SITES_FOR_INVITATION_SUCCESS = '[projects] fetch project sites for invitation success';
export const FetchProjectSitesForInvitationSuccess = createAction(
  FETCH_PROJECT_SITES_FOR_INVITATION_SUCCESS,
  props<any>()
);

const FETCH_PROJECT_SITES_FOR_INVITATION_FAILURE = '[projects] fetch project sites for invitation failure';
export const FetchProjectSitesForInvitationFailure = createAction(FETCH_PROJECT_SITES_FOR_INVITATION_FAILURE);

/********** [/projects] [WRAPPER]  ************/

/******** CREATE DAILY REPORT ***********/
const CREATE_DAILY_REPORT_REQUEST = '[projects] create daily report request';
export const CreateDailyReportRequest = createAction(CREATE_DAILY_REPORT_REQUEST, props<any>());

const CREATE_DAILY_REPORT_SUCCESS = '[projects] create daily report success';
export const CreateDailyReportSuccess = createAction(CREATE_DAILY_REPORT_SUCCESS, props<any>());

const CREATE_DAILY_REPORT_FAILURE = '[projects] create daily report failure';
export const CreateDailyReportFailure = createAction(CREATE_DAILY_REPORT_FAILURE);

/******** CREATE DAILY REPORT DRAFT ***********/
const CREATE_DAILY_REPORT_DRAFT_REQUEST = '[projects] create daily report draft request';
export const CreateDailyReportDraftRequest = createAction(CREATE_DAILY_REPORT_DRAFT_REQUEST, props<any>());

const CREATE_DAILY_REPORT_DRAFT_SUCCESS = '[projects] create daily report draft success';
export const CreateDailyReportDraftSuccess = createAction(CREATE_DAILY_REPORT_DRAFT_SUCCESS, props<any>());

const CREATE_DAILY_REPORT_DRAFT_FAILURE = '[projects] create daily report draft failure';
export const CreateDailyReportDraftFailure = createAction(CREATE_DAILY_REPORT_DRAFT_FAILURE);

/******** CHECK DAILY REPORT STATUS ***********/
const CHECK_IF_DAILY_REPORT_CAN_BE_CREATED_REQUEST = '[projects] check if daily report can be created request';
export const CheckIfDailyReportCanBeCreatedRequest = createAction(
  CHECK_IF_DAILY_REPORT_CAN_BE_CREATED_REQUEST,
  props<any>()
);

const CHECK_IF_DAILY_REPORT_CAN_BE_CREATED_SUCCESS = '[projects] check if daily report can be created success';
export const CheckIfDailyReportCanBeCreatedSuccess = createAction(
  CHECK_IF_DAILY_REPORT_CAN_BE_CREATED_SUCCESS,
  props<any>()
);

const CHECK_IF_DAILY_REPORT_CAN_BE_CREATED_FAILURE = '[projects] check if daily report can be created failure';
export const CheckIfDailyReportCanBeCreatedFailure = createAction(CHECK_IF_DAILY_REPORT_CAN_BE_CREATED_FAILURE);

/********** [/projects/:projectId?tab=consolidated-reports]  ************/

/******** FETCH PROJECTS REPORTS LIST ***********/
const FETCH_PROJECT_REPORTS_LIST_REQUEST = '[projects] fetch project reports list request';
export const FetchProjectReportsListRequest = createAction(FETCH_PROJECT_REPORTS_LIST_REQUEST, props<any>());

const FETCH_PROJECT_REPORTS_LIST_SUCCESS = '[projects] fetch project reports list success';
export const FetchProjectReportsListSuccess = createAction(FETCH_PROJECT_REPORTS_LIST_SUCCESS, props<any>());

const FETCH_PROJECT_REPORTS_LIST_FAILURE = '[projects] fetch project reports list failure';
export const FetchProjectReportsListFailure = createAction(FETCH_PROJECT_REPORTS_LIST_FAILURE);

/******** FETCH PROJECTS REPORT ***********/
const FETCH_PROJECT_REPORT_REQUEST = '[projects] fetch project report request';
export const FetchProjectReportRequest = createAction(FETCH_PROJECT_REPORT_REQUEST, props<any>());

const FETCH_PROJECT_REPORT_SUCCESS = '[projects] fetch project report success';
export const FetchProjectReportSuccess = createAction(FETCH_PROJECT_REPORT_SUCCESS, props<any>());

const FETCH_PROJECT_REPORT_FAILURE = '[projects] fetch project report failure';
export const FetchProjectReportFailure = createAction(FETCH_PROJECT_REPORT_FAILURE);

/******** FETCH PAYAPP ITEMS ***********/
const FETCH_PAYAPP_ITEMS_REQUEST = '[projects] fetch payapp items request';
export const FetchPayappItemsRequest = createAction(FETCH_PAYAPP_ITEMS_REQUEST, props<any>());

const FETCH_PAYAPP_ITEMS_SUCCESS = '[projects] fetch payapp items success';
export const FetchPayappItemsSuccess = createAction(FETCH_PAYAPP_ITEMS_SUCCESS, props<any>());

const FETCH_PAYAPP_ITEMS_FAILURE = '[projects] fetch payapp items failure';
export const FetchPayappItemsFailure = createAction(FETCH_PAYAPP_ITEMS_FAILURE);

/******** FETCH PAYAPPS ***********/
const FETCH_PAYAPPS_REQUEST = '[projects] fetch payapps request';
export const FetchPayappsRequest = createAction(FETCH_PAYAPPS_REQUEST, props<any>());

const FETCH_PAYAPPS_SUCCESS = '[projects] fetch payapps success';
export const FetchPayappsSuccess = createAction(FETCH_PAYAPPS_SUCCESS, props<any>());

const FETCH_PAYAPPS_FAILURE = '[projects] fetch payapps failure';
export const FetchPayappsFailure = createAction(FETCH_PAYAPPS_FAILURE);

/******** FETCH PAYAPPS ***********/
const FETCH_PAYAPPDETAILS_REQUEST = '[projects] fetch payapp details request';
export const FetchPayappDetailsRequest = createAction(FETCH_PAYAPPDETAILS_REQUEST, props<any>());

const FETCH_PAYAPPDETAILS_SUCCESS = '[projects] fetch payapp details success';
export const FetchPayappDetailsSuccess = createAction(FETCH_PAYAPPDETAILS_SUCCESS, props<any>());

const FETCH_PAYAPPDETAILS_FAILURE = '[projects] fetch payapp details failure';
export const FetchPayappDetailsFailure = createAction(FETCH_PAYAPPDETAILS_FAILURE);

/******** GENERATE PAYAPP  ***********/
const GENERATE_PAYAPP_REQUEST = '[projects] generate payapp request';
export const GeneratePayappRequest = createAction(GENERATE_PAYAPP_REQUEST, props<any>());

const GENERATE_PAYAPP_SUCCESS = '[projects] generate payapp success';
export const GeneratePayappSuccess = createAction(GENERATE_PAYAPP_SUCCESS, props<any>());

const GENERATE_PAYAPP_FAILURE = '[projects] generate payapp failure';
export const GeneratePayappFailure = createAction(GENERATE_PAYAPP_FAILURE);

/******** DELETE PAYAPP  ***********/
const DELETE_PAYAPP_REQUEST = '[projects] delete payapp request';
export const DeletePayappRequest = createAction(DELETE_PAYAPP_REQUEST, props<any>());

const DELETE_PAYAPP_SUCCESS = '[projects] delete payapp success';
export const DeletePayappSuccess = createAction(DELETE_PAYAPP_SUCCESS, props<any>());

const DELETE_PAYAPP_FAILURE = '[projects] delete payapp failure';
export const DeletePayappFailure = createAction(DELETE_PAYAPP_FAILURE);

/******** UPDATE PAYAPP STATUS  ***********/
const UPDATE_PAYAPP_STATUS_REQUEST = '[projects] update payapp status request';
export const UpdatePayappStatusRequest = createAction(UPDATE_PAYAPP_STATUS_REQUEST, props<any>());

const UPDATE_PAYAPP_STATUS_SUCCESS = '[projects] update payapp status success';
export const UpdatePayappStatusSuccess = createAction(UPDATE_PAYAPP_STATUS_SUCCESS, props<any>());

const UPDATE_PAYAPP_STATUS_FAILURE = '[projects] update payapp status failure';
export const UpdatePayappStatusFailure = createAction(UPDATE_PAYAPP_STATUS_FAILURE);

/******** ADD CONTRACTOR STATUS ***********/
const ADD_CONTRACTOR_STATUS_REQUEST = '[projects] add contractor status request';
export const AddContractorStatusRequest = createAction(ADD_CONTRACTOR_STATUS_REQUEST, props<any>());

const ADD_CONTRACTOR_STATUS_SUCCESS = '[projects] add contractor status success';
export const AddContractorStatusSuccess = createAction(ADD_CONTRACTOR_STATUS_SUCCESS, props<any>());

const ADD_CONTRACTOR_STATUS_FAILURE = '[projects] add contractor status failure';
export const AddContractorStatusFailure = createAction(ADD_CONTRACTOR_STATUS_FAILURE);

/******** CLEAR BID SHEET ***********/
const CLEAR_BID_SHEET = '[projects] clear bid sheet';
export const ClearBidSheet = createAction(CLEAR_BID_SHEET);

/******** FETCH BID SHEET ***********/
const FETCH_BID_SHEET_REQUEST = '[projects] fetch bid sheet request';
export const FetchBidSheetRequest = createAction(FETCH_BID_SHEET_REQUEST, props<any>());

const FETCH_BID_SHEET_SUCCESS = '[projects] fetch bid sheet success';
export const FetchBidSheetSuccess = createAction(FETCH_BID_SHEET_SUCCESS, props<any>());

const FETCH_BID_SHEET_FAILURE = '[projects] fetch bid sheet failure';
export const FetchBidSheetFailure = createAction(FETCH_BID_SHEET_FAILURE, props<any>());

/******** FETCH SETTINGS BID SHEET ***********/
const FETCH_SETTINGS_BID_SHEET_REQUEST = '[projects] fetch settings bid sheet request';
export const FetchSettingsBidSheetRequest = createAction(FETCH_SETTINGS_BID_SHEET_REQUEST, props<any>());

const FETCH_SETTINGS_BID_SHEET_SUCCESS = '[projects] fetch settings bid sheet success';
export const FetchSettingsBidSheetSuccess = createAction(
  FETCH_SETTINGS_BID_SHEET_SUCCESS,
  props<{ settingsBidSheet: any }>()
);

const FETCH_SETTINGS_BID_SHEET_FAILURE = '[projects] fetch settings bid sheet failure';
export const FetchSettingsBidSheetFailure = createAction(FETCH_SETTINGS_BID_SHEET_FAILURE, props<any>());

/******** FETCH SETTINGS BID ITEMS (after settings bid sheet) ***********/
const FETCH_SETTINGS_BID_ITEMS_REQUEST = '[projects] fetch settings bid items request';
export const FetchSettingsBidItemsRequest = createAction(FETCH_SETTINGS_BID_ITEMS_REQUEST, props<any>());

const FETCH_SETTINGS_BID_ITEMS_SUCCESS = '[projects] fetch settings bid items success';
export const FetchSettingsBidItemsSuccess = createAction(
  FETCH_SETTINGS_BID_ITEMS_SUCCESS,
  props<{ settingsBidItemsListInfo: { list: any[]; totalRecords: number } }>()
);

const FETCH_SETTINGS_BID_ITEMS_FAILURE = '[projects] fetch settings bid items failure';
export const FetchSettingsBidItemsFailure = createAction(FETCH_SETTINGS_BID_ITEMS_FAILURE, props<any>());

/******** FETCH SETTINGS BID ITEM DETAILS (single bid item) ***********/
const FETCH_SETTINGS_BID_ITEM_DETAILS_REQUEST = '[projects] fetch settings bid item details request';
export const FetchSettingsBidItemDetailsRequest = createAction(
  FETCH_SETTINGS_BID_ITEM_DETAILS_REQUEST,
  props<{ bidItemId: string; qp?: any }>()
);

const FETCH_SETTINGS_BID_ITEM_DETAILS_SUCCESS = '[projects] fetch settings bid item details success';
export const FetchSettingsBidItemDetailsSuccess = createAction(
  FETCH_SETTINGS_BID_ITEM_DETAILS_SUCCESS,
  props<{ bidItemId: string; bidItem: any }>()
);

const FETCH_SETTINGS_BID_ITEM_DETAILS_FAILURE = '[projects] fetch settings bid item details failure';
export const FetchSettingsBidItemDetailsFailure = createAction(
  FETCH_SETTINGS_BID_ITEM_DETAILS_FAILURE,
  props<{ bidItemId: string }>()
);

/******** FETCH BID ITEM FIELDS ***********/
const FETCH_BID_ITEM_FIELDS_REQUEST = '[projects] fetch bid item fields request';
export const FetchBidItemFieldsRequest = createAction(FETCH_BID_ITEM_FIELDS_REQUEST, props<any>());

const FETCH_BID_ITEM_FIELDS_SUCCESS = '[projects] fetch bid item fields success';
export const FetchBidItemFieldsSuccess = createAction(
  FETCH_BID_ITEM_FIELDS_SUCCESS,
  props<{ list: any[] }>()
);

const FETCH_BID_ITEM_FIELDS_FAILURE = '[projects] fetch bid item fields failure';
export const FetchBidItemFieldsFailure = createAction(FETCH_BID_ITEM_FIELDS_FAILURE, props<any>());

/******** SETTINGS CREATE BID ITEM ***********/
const SETTINGS_CREATE_BID_ITEM_REQUEST = '[projects] settings create bid item request';
export const SettingsCreateBidItemRequest = createAction(
  SETTINGS_CREATE_BID_ITEM_REQUEST,
  props<{ payload: { projectId: string; bidSheetId: string; body: any } }>()
);
const SETTINGS_CREATE_BID_ITEM_SUCCESS = '[projects] settings create bid item success';
export const SettingsCreateBidItemSuccess = createAction(SETTINGS_CREATE_BID_ITEM_SUCCESS, props<{ bidItem: any }>());
const SETTINGS_CREATE_BID_ITEM_FAILURE = '[projects] settings create bid item failure';
export const SettingsCreateBidItemFailure = createAction(SETTINGS_CREATE_BID_ITEM_FAILURE);

/******** SETTINGS UPDATE BID ITEM ***********/
const SETTINGS_UPDATE_BID_ITEM_REQUEST = '[projects] settings update bid item request';
export const SettingsUpdateBidItemRequest = createAction(
  SETTINGS_UPDATE_BID_ITEM_REQUEST,
  props<{ payload: { projectId: string; bidItemId: string; body: any } }>()
);
const SETTINGS_UPDATE_BID_ITEM_SUCCESS = '[projects] settings update bid item success';
export const SettingsUpdateBidItemSuccess = createAction(SETTINGS_UPDATE_BID_ITEM_SUCCESS, props<{ bidItem: any }>());
const SETTINGS_UPDATE_BID_ITEM_FAILURE = '[projects] settings update bid item failure';
export const SettingsUpdateBidItemFailure = createAction(SETTINGS_UPDATE_BID_ITEM_FAILURE);

/******** SETTINGS DELETE BID ITEM ***********/
const SETTINGS_DELETE_BID_ITEM_REQUEST = '[projects] settings delete bid item request';
export const SettingsDeleteBidItemRequest = createAction(
  SETTINGS_DELETE_BID_ITEM_REQUEST,
  props<{ payload: { projectId: string; bidItemId: string } }>()
);
const SETTINGS_DELETE_BID_ITEM_SUCCESS = '[projects] settings delete bid item success';
export const SettingsDeleteBidItemSuccess = createAction(SETTINGS_DELETE_BID_ITEM_SUCCESS, props<{ bidItemId: string }>());
const SETTINGS_DELETE_BID_ITEM_FAILURE = '[projects] settings delete bid item failure';
export const SettingsDeleteBidItemFailure = createAction(SETTINGS_DELETE_BID_ITEM_FAILURE);

/******** SETTINGS CREATE BID ITEM FIELD ***********/
const SETTINGS_CREATE_BID_ITEM_FIELD_REQUEST = '[projects] settings create bid item field request';
export const SettingsCreateBidItemFieldRequest = createAction(
  SETTINGS_CREATE_BID_ITEM_FIELD_REQUEST,
  props<{ bidItemId: string; body: any }>()
);
const SETTINGS_CREATE_BID_ITEM_FIELD_SUCCESS = '[projects] settings create bid item field success';
export const SettingsCreateBidItemFieldSuccess = createAction(
  SETTINGS_CREATE_BID_ITEM_FIELD_SUCCESS,
  props<{ bidItemId: string; field: any }>()
);
const SETTINGS_CREATE_BID_ITEM_FIELD_FAILURE = '[projects] settings create bid item field failure';
export const SettingsCreateBidItemFieldFailure = createAction(SETTINGS_CREATE_BID_ITEM_FIELD_FAILURE);

/******** SETTINGS UPDATE BID ITEM FIELD ***********/
const SETTINGS_UPDATE_BID_ITEM_FIELD_REQUEST = '[projects] settings update bid item field request';
export const SettingsUpdateBidItemFieldRequest = createAction(
  SETTINGS_UPDATE_BID_ITEM_FIELD_REQUEST,
  props<{ fieldId: string; bidItemId: string; body: any }>()
);
const SETTINGS_UPDATE_BID_ITEM_FIELD_SUCCESS = '[projects] settings update bid item field success';
export const SettingsUpdateBidItemFieldSuccess = createAction(
  SETTINGS_UPDATE_BID_ITEM_FIELD_SUCCESS,
  props<{ bidItemId: string; field: any }>()
);
const SETTINGS_UPDATE_BID_ITEM_FIELD_FAILURE = '[projects] settings update bid item field failure';
export const SettingsUpdateBidItemFieldFailure = createAction(SETTINGS_UPDATE_BID_ITEM_FIELD_FAILURE);

/******** FETCH SETTINGS PROJECT MATERIALS LIST ***********/
const FETCH_SETTINGS_PROJECT_MATERIALS_LIST_REQUEST = '[projects] fetch settings project materials list request';
export const FetchSettingsProjectMaterialsListRequest = createAction(
  FETCH_SETTINGS_PROJECT_MATERIALS_LIST_REQUEST,
  props<{ projectId: string; qp?: any }>()
);
const FETCH_SETTINGS_PROJECT_MATERIALS_LIST_SUCCESS = '[projects] fetch settings project materials list success';
export const FetchSettingsProjectMaterialsListSuccess = createAction(
  FETCH_SETTINGS_PROJECT_MATERIALS_LIST_SUCCESS,
  props<{ projectId: string; list: any[] }>()
);
const FETCH_SETTINGS_PROJECT_MATERIALS_LIST_FAILURE = '[projects] fetch settings project materials list failure';
export const FetchSettingsProjectMaterialsListFailure = createAction(
  FETCH_SETTINGS_PROJECT_MATERIALS_LIST_FAILURE,
  props<{ projectId: string }>()
);

/******** SETTINGS ADD MATERIAL TO BID ITEM ***********/
const SETTINGS_ADD_MATERIAL_TO_BID_ITEM_REQUEST = '[projects] settings add material to bid item request';
export const SettingsAddMaterialToBidItemRequest = createAction(
  SETTINGS_ADD_MATERIAL_TO_BID_ITEM_REQUEST,
  props<{ materialId: string; bidItemId: string }>()
);
const SETTINGS_ADD_MATERIAL_TO_BID_ITEM_SUCCESS = '[projects] settings add material to bid item success';
export const SettingsAddMaterialToBidItemSuccess = createAction(
  SETTINGS_ADD_MATERIAL_TO_BID_ITEM_SUCCESS,
  props<{ materialId: string; bidItemId: string }>()
);
const SETTINGS_ADD_MATERIAL_TO_BID_ITEM_FAILURE = '[projects] settings add material to bid item failure';
export const SettingsAddMaterialToBidItemFailure = createAction(SETTINGS_ADD_MATERIAL_TO_BID_ITEM_FAILURE);

/******** SETTINGS REMOVE MATERIAL FROM BID ITEM ***********/
const SETTINGS_REMOVE_MATERIAL_FROM_BID_ITEM_REQUEST = '[projects] settings remove material from bid item request';
export const SettingsRemoveMaterialFromBidItemRequest = createAction(
  SETTINGS_REMOVE_MATERIAL_FROM_BID_ITEM_REQUEST,
  props<{ materialId: string; bidItemId: string }>()
);
const SETTINGS_REMOVE_MATERIAL_FROM_BID_ITEM_SUCCESS = '[projects] settings remove material from bid item success';
export const SettingsRemoveMaterialFromBidItemSuccess = createAction(
  SETTINGS_REMOVE_MATERIAL_FROM_BID_ITEM_SUCCESS,
  props<{ materialId: string; bidItemId: string }>()
);
const SETTINGS_REMOVE_MATERIAL_FROM_BID_ITEM_FAILURE = '[projects] settings remove material from bid item failure';
export const SettingsRemoveMaterialFromBidItemFailure = createAction(SETTINGS_REMOVE_MATERIAL_FROM_BID_ITEM_FAILURE);

/******** SETTINGS UPDATE BID ITEM SITE QUANTITY ***********/
const SETTINGS_UPDATE_BID_ITEM_SITE_QUANTITY_REQUEST = '[projects] settings update bid item site quantity request';
export const SettingsUpdateBidItemSiteQuantityRequest = createAction(
  SETTINGS_UPDATE_BID_ITEM_SITE_QUANTITY_REQUEST,
  props<{ bidItemId: string; siteId: string; quantity: number }>()
);
const SETTINGS_UPDATE_BID_ITEM_SITE_QUANTITY_SUCCESS = '[projects] settings update bid item site quantity success';
export const SettingsUpdateBidItemSiteQuantitySuccess = createAction(
  SETTINGS_UPDATE_BID_ITEM_SITE_QUANTITY_SUCCESS,
  props<{ bidItemId: string; siteId: string; quantity: number }>()
);
const SETTINGS_UPDATE_BID_ITEM_SITE_QUANTITY_FAILURE = '[projects] settings update bid item site quantity failure';
export const SettingsUpdateBidItemSiteQuantityFailure = createAction(
  SETTINGS_UPDATE_BID_ITEM_SITE_QUANTITY_FAILURE
);

/******** FETCH BID ITEMS ***********/
const FETCH_BID_ITEMS_REQUEST = '[projects] fetch bid items request';
export const FetchBidItemsListRequest = createAction(FETCH_BID_ITEMS_REQUEST, props<any>());

const FETCH_BID_ITEMS_SUCCESS = '[projects] fetch bid items success';
export const FetchBidItemsListSuccess = createAction(FETCH_BID_ITEMS_SUCCESS, props<any>());

const FETCH_BID_ITEMS_FAILURE = '[projects] fetch bid items failure';
export const FetchBidItemsListFailure = createAction(FETCH_BID_ITEMS_FAILURE, props<any>());

/******** UPLOAD CHANGE ORDER FILE ***********/
const UPLOAD_CHANGE_ORDER_FILE_REQUEST = '[projects] upload change order file request';
export const UploadChangeOrderFileRequest = createAction(UPLOAD_CHANGE_ORDER_FILE_REQUEST, props<any>());

const UPLOAD_CHANGE_ORDER_FILE_SUCCESS = '[projects] upload change order file success';
export const UploadChangeOrderFileSuccess = createAction(UPLOAD_CHANGE_ORDER_FILE_SUCCESS, props<any>());

const UPLOAD_CHANGE_ORDER_FILE_FAILURE = '[projects] upload change order file failure';
export const UploadChangeOrderFileFailure = createAction(UPLOAD_CHANGE_ORDER_FILE_FAILURE, props<any>());

/******** UPLOAD SETTINGS BID SHEET CSV ***********/
const UPLOAD_SETTINGS_BID_SHEET_CSV_REQUEST = '[projects] upload settings bid sheet csv request';
export const UploadSettingsBidSheetCsvRequest = createAction(
  UPLOAD_SETTINGS_BID_SHEET_CSV_REQUEST,
  props<any>()
);
const UPLOAD_SETTINGS_BID_SHEET_CSV_SUCCESS = '[projects] upload settings bid sheet csv success';
export const UploadSettingsBidSheetCsvSuccess = createAction(
  UPLOAD_SETTINGS_BID_SHEET_CSV_SUCCESS,
  props<any>()
);
const UPLOAD_SETTINGS_BID_SHEET_CSV_FAILURE = '[projects] upload settings bid sheet csv failure';
export const UploadSettingsBidSheetCsvFailure = createAction(
  UPLOAD_SETTINGS_BID_SHEET_CSV_FAILURE,
  props<any>()
);

/******** FETCH BID ITEMS SITES LIST ***********/
const FETCH_BID_ITEMS_SITES_LIST_REQUEST = '[projects] fetch bid items sites list request';
export const FetchBidItemsSitesListRequest = createAction(FETCH_BID_ITEMS_SITES_LIST_REQUEST, props<any>());

const FETCH_BID_ITEMS_SITES_LIST_SUCCESS = '[projects] fetch bid items sites list success';
export const FetchBidItemsSitesListSuccess = createAction(FETCH_BID_ITEMS_SITES_LIST_SUCCESS, props<any>());

const FETCH_BID_ITEMS_SITES_LIST_FAILURE = '[projects] fetch bid items sites list failure';
export const FetchBidItemsSitesListFailure = createAction(FETCH_BID_ITEMS_SITES_LIST_FAILURE, props<any>());

/******** FETCH CHANGE ORDER FILTER ***********/
const FETCH_CHANGE_ORDER_FILTER_REQUEST = '[projects] fetch change order filter request';
export const FetchChangeOrderFilterRequest = createAction(FETCH_CHANGE_ORDER_FILTER_REQUEST, props<any>());

const FETCH_CHANGE_ORDER_FILTER_SUCCESS = '[projects] fetch change order filter success';
export const FetchChangeOrderFilterSuccess = createAction(FETCH_CHANGE_ORDER_FILTER_SUCCESS, props<any>());

const FETCH_CHANGE_ORDER_FILTER_FAILURE = '[projects] fetch change order filter failure';
export const FetchChangeOrderFilterFailure = createAction(FETCH_CHANGE_ORDER_FILTER_FAILURE, props<any>());

/******** FETCH BID ITEM LIST WITH CHANGE ORDER ***********/
const FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_REQUEST = '[projects] fetch bid item list with change order request';
export const FetchBidItemListWithChangeOrderRequest = createAction(
  FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_REQUEST,
  props<any>()
);

const FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_SUCCESS = '[projects] fetch bid item list with change order success';
export const FetchBidItemListWithChangeOrderSuccess = createAction(
  FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_SUCCESS,
  props<any>()
);

const FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_FAILURE = '[projects] fetch bid item list with change order failure';
export const FetchBidItemListWithChangeOrderFailure = createAction(
  FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_FAILURE,
  props<any>()
);

/******** FETCH CHANGE ORDER FILTER IN SIDE NAV ***********/
const FETCH_CHANGE_ORDER_FILTER_IN_SIDE_NAV_REQUEST = '[projects] fetch change order filter in side nav request';
export const FetchChangeOrderFilterInSideNavRequest = createAction(
  FETCH_CHANGE_ORDER_FILTER_IN_SIDE_NAV_REQUEST,
  props<any>()
);

const FETCH_CHANGE_ORDER_FILTER_IN_SIDE_NAV_SUCCESS = '[projects] fetch change order filter in side nav success';
export const FetchChangeOrderFilterInSideNavSuccess = createAction(
  FETCH_CHANGE_ORDER_FILTER_IN_SIDE_NAV_SUCCESS,
  props<any>()
);

const FETCH_CHANGE_ORDER_FILTER_IN_SIDE_NAV_FAILURE = '[projects] fetch change order filter in side nav failure';
export const FetchChangeOrderFilterInSideNavFailure = createAction(
  FETCH_CHANGE_ORDER_FILTER_IN_SIDE_NAV_FAILURE,
  props<any>()
);

/******** FETCH BID ITEM LIST WITH CHANGE ORDER IN SIDE NAV ***********/
const FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_IN_SIDE_NAV_REQUEST =
  '[projects] fetch bid item list with change order in side nav request';
export const FetchBidItemListWithChangeOrderInSideNavRequest = createAction(
  FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_IN_SIDE_NAV_REQUEST,
  props<any>()
);

const FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_IN_SIDE_NAV_SUCCESS =
  '[projects] fetch bid item list with change order in side nav success';
export const FetchBidItemListWithChangeOrderInSideNavSuccess = createAction(
  FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_IN_SIDE_NAV_SUCCESS,
  props<any>()
);

const FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_IN_SIDE_NAV_FAILURE =
  '[projects] fetch bid item list with change order in side nav failure';
export const FetchBidItemListWithChangeOrderInSideNavFailure = createAction(
  FETCH_BID_ITEM_LIST_WITH_CHANGE_ORDER_IN_SIDE_NAV_FAILURE,
  props<any>()
);
/********** [/projects/:projectId/sites/:siteId?tab=daily-report]  ************/

/******** FETCH SITE DETAILS ***********/
const FETCH_SITE_DETAILS_REQUEST = '[projects] fetch site details request';
export const FetchSiteDetailsRequest = createAction(FETCH_SITE_DETAILS_REQUEST, props<any>());

const FETCH_SITE_DETAILS_SUCCESS = '[projects] fetch site details success';
export const FetchSiteDetailsSuccess = createAction(FETCH_SITE_DETAILS_SUCCESS, props<any>());

const FETCH_SITE_DETAILS_FAILURE = '[projects] fetch site details failure';
export const FetchSiteDetailsFailure = createAction(FETCH_SITE_DETAILS_FAILURE);

/******** FETCH DAILY REPORTS BY DATE ***********/
const FETCH_DAILY_REPORTS_BY_DATE_REQUEST = '[projects] fetch daily reports by date request';
export const FetchDailyReportsByDateRequest = createAction(FETCH_DAILY_REPORTS_BY_DATE_REQUEST, props<any>());

const FETCH_DAILY_REPORTS_BY_DATE_SUCCESS = '[projects] fetch daily reports by date success';
export const FetchDailyReportsByDateSuccess = createAction(FETCH_DAILY_REPORTS_BY_DATE_SUCCESS, props<any>());

const FETCH_DAILY_REPORTS_BY_DATE_FAILURE = '[projects] fetch daily reports by date failure';
export const FetchDailyReportsByDateFailure = createAction(FETCH_DAILY_REPORTS_BY_DATE_FAILURE);

/******** CLEAR DAILY REPORT ***********/
const CLEAR_DAILY_REPORT_REQUEST = '[projects] clear daily report request';
export const ClearDailyReportRequest = createAction(CLEAR_DAILY_REPORT_REQUEST);

/******** FETCH DAILY REPORT ***********/
const FETCH_DAILY_REPORT_REQUEST = '[projects] fetch daily report request';
export const FetchDailyReportRequest = createAction(FETCH_DAILY_REPORT_REQUEST, props<any>());

const FETCH_DAILY_REPORT_SUCCESS = '[projects] fetch daily report success';
export const FetchDailyReportSuccess = createAction(FETCH_DAILY_REPORT_SUCCESS, props<any>());

const FETCH_DAILY_REPORT_FAILURE = '[projects] fetch daily report failure';
export const FetchDailyReportFailure = createAction(FETCH_DAILY_REPORT_FAILURE);

/******** SAVE DAILY REPORT ***********/
const SAVE_DAILY_REPORT_REQUEST = '[projects] save daily report request';
export const SaveDailyReportRequest = createAction(SAVE_DAILY_REPORT_REQUEST, props<any>());

const SAVE_DAILY_REPORT_SUCCESS = '[projects] save daily report success';
export const SaveDailyReportSuccess = createAction(SAVE_DAILY_REPORT_SUCCESS, props<any>());

const SAVE_DAILY_REPORT_FAILURE = '[projects] save daily report failure';
export const SaveDailyReportFailure = createAction(SAVE_DAILY_REPORT_FAILURE, props<any>());

/******** COPY DAILY REPORT ***********/
const COPY_DAILY_REPORT_REQUEST = '[projects] copy daily report request';
export const CopyDailyReportRequest = createAction(COPY_DAILY_REPORT_REQUEST, props<any>());

const COPY_DAILY_REPORT_SUCCESS = '[projects] copy daily report success';
export const CopyDailyReportSuccess = createAction(COPY_DAILY_REPORT_SUCCESS, props<any>());

const COPY_DAILY_REPORT_FAILURE = '[projects] copy daily report failure';
export const CopyDailyReportFailure = createAction(COPY_DAILY_REPORT_FAILURE);

/******** FETCH ALL BID ITEMS ***********/
const FETCH_ALL_BID_ITEMS_REQUEST = '[projects] fetch all bid items request';
export const FetchAllBidItemsRequest = createAction(FETCH_ALL_BID_ITEMS_REQUEST, props<any>());

const FETCH_ALL_BID_ITEMS_SUCCESS = '[projects] fetch all bid items success';
export const FetchAllBidItemsSuccess = createAction(FETCH_ALL_BID_ITEMS_SUCCESS, props<any>());

const FETCH_ALL_BID_ITEMS_FAILURE = '[projects] fetch all bid items failure';
export const FetchAllBidItemsFailure = createAction(FETCH_ALL_BID_ITEMS_FAILURE);

/******** FETCH ISSUE TYPES ***********/
const FETCH_ISSUE_TYPES_REQUEST = '[projects] fetch issue types request';
export const FetchIssueTypesRequest = createAction(FETCH_ISSUE_TYPES_REQUEST, props<any>());

const FETCH_ISSUE_TYPES_SUCCESS = '[projects] fetch issue types success';
export const FetchIssueTypesSuccess = createAction(FETCH_ISSUE_TYPES_SUCCESS, props<any>());

const FETCH_ISSUE_TYPES_FAILURE = '[projects] fetch issue types failure';
export const FetchIssueTypesFailure = createAction(FETCH_ISSUE_TYPES_FAILURE);

/******** CLEAR SITES LIST ***********/
const CLEAR_SITES_LIST_REQUEST = '[projects] clear sites list request';
export const ClearSitesListRequest = createAction(CLEAR_SITES_LIST_REQUEST);

/******** FETCH SUB CONTRACTOR FILTER ***********/
const FETCH_SUB_CONTRACTOR_FILTER_REQUEST = '[projects] fetch sub contractor filter request';
export const FetchSubContractorFilterRequest = createAction(FETCH_SUB_CONTRACTOR_FILTER_REQUEST, props<any>());

const FETCH_SUB_CONTRACTOR_FILTER_SUCCESS = '[projects] fetch sub contractor filter success';
export const FetchSubContractorFilterSuccess = createAction(FETCH_SUB_CONTRACTOR_FILTER_SUCCESS, props<any>());

const FETCH_SUB_CONTRACTOR_FILTER_FAILURE = '[projects] fetch sub contractor filter failure';
export const FetchSubContractorFilterFailure = createAction(FETCH_SUB_CONTRACTOR_FILTER_FAILURE, props<any>());

/******** FETCH LABOR FILTER ***********/
const FETCH_LABOR_FILTER_REQUEST = '[projects] fetch labor filter request';
export const FetchLaborFilterRequest = createAction(FETCH_LABOR_FILTER_REQUEST, props<any>());

const FETCH_LABOR_FILTER_SUCCESS = '[projects] fetch labor filter success';
export const FetchLaborFilterSuccess = createAction(FETCH_LABOR_FILTER_SUCCESS, props<any>());

const FETCH_LABOR_FILTER_FAILURE = '[projects] fetch labor filter failure';
export const FetchLaborFilterFailure = createAction(FETCH_LABOR_FILTER_FAILURE, props<any>());

/******** FETCH EQUIPMENT FILTER ***********/
const FETCH_EQUIPMENT_FILTER_REQUEST = '[projects] fetch equipment filter request';
export const FetchEquipmentFilterRequest = createAction(FETCH_EQUIPMENT_FILTER_REQUEST, props<any>());

const FETCH_EQUIPMENT_FILTER_SUCCESS = '[projects] fetch equipment filter success';
export const FetchEquipmentFilterSuccess = createAction(FETCH_EQUIPMENT_FILTER_SUCCESS, props<any>());

const FETCH_EQUIPMENT_FILTER_FAILURE = '[projects] fetch equipment filter failure';
export const FetchEquipmentFilterFailure = createAction(FETCH_EQUIPMENT_FILTER_FAILURE, props<any>());

/******** UPDATE ISSUE DETAILS  ***********/
const UPDATE_ISSUE_DETAILS_REQUEST = '[projects] update issues details request';
export const UpdateIssuesDetailsRequest = createAction(UPDATE_ISSUE_DETAILS_REQUEST, props<any>());

const UPDATE_ISSUE_DETAILS_SUCCESS = '[projects] update issues details success';
export const UpdateIssuesDetailsSuccess = createAction(UPDATE_ISSUE_DETAILS_SUCCESS, props<any>());

const UPDATE_ISSUE_DETAILS_FAILURE = '[projects] update issues details failure';
export const UpdateIssuesDetailsFailure = createAction(UPDATE_ISSUE_DETAILS_FAILURE);

/******** ADD ISSUE DETAILS  ***********/
const ADD_ISSUE_DETAILS_REQUEST = '[projects] add issues details request';
export const AddIssuesDetailsRequest = createAction(ADD_ISSUE_DETAILS_REQUEST, props<any>());

const ADD_ISSUE_DETAILS_SUCCESS = '[projects] add issues details success';
export const AddIssuesDetailsSuccess = createAction(ADD_ISSUE_DETAILS_SUCCESS, props<any>());

const ADD_ISSUE_DETAILS_FAILURE = '[projects] add issues details failure';
export const AddIssuesDetailsFailure = createAction(ADD_ISSUE_DETAILS_FAILURE);

/******** CHANGE ISSUE STATUS  ***********/
const CHANGE_ISSUE_STATUS_REQUEST = '[projects] change issue status request';
export const ChangeIssueStatusRequest = createAction(CHANGE_ISSUE_STATUS_REQUEST, props<any>());

const CHANGE_ISSUE_STATUS_SUCCESS = '[projects] change issue status success';
export const ChangeIssueStatusSuccess = createAction(CHANGE_ISSUE_STATUS_SUCCESS, props<any>());

const CHANGE_ISSUE_STATUS_FAILURE = '[projects] change issue status failure';
export const ChangeIssueStatusFailure = createAction(CHANGE_ISSUE_STATUS_FAILURE);

/******** EXECUTE CURRENT ACTION STATE  ***********/
const EXECUTE_CURRENT_ACTION_STATE_REQUEST = '[projects] execute current action state request';
export const ExecuteCurrentActionStateRequest = createAction(EXECUTE_CURRENT_ACTION_STATE_REQUEST, props<any>());

const EXECUTE_CURRENT_ACTION_STATE_SUCCESS = '[projects] execute current action state success';
export const ExecuteCurrentActionStateSuccess = createAction(EXECUTE_CURRENT_ACTION_STATE_SUCCESS, props<any>());

const EXECUTE_CURRENT_ACTION_STATE_FAILURE = '[projects] execute current action state failure';
export const ExecuteCurrentActionStateFailure = createAction(EXECUTE_CURRENT_ACTION_STATE_FAILURE);

/******** FETCH NEXT ACTION STATE  ***********/
const FETCH_NEXT_ACTION_STATE_REQUEST = '[projects] fetch next action state request';
export const FetchNextActionStateRequest = createAction(FETCH_NEXT_ACTION_STATE_REQUEST, props<any>());

const FETCH_NEXT_ACTION_STATE_SUCCESS = '[projects] fetch next action state success';
export const FetchNextActionStateSuccess = createAction(FETCH_NEXT_ACTION_STATE_SUCCESS, props<any>());

const FETCH_NEXT_ACTION_STATE_FAILURE = '[projects] fetch next action state failure';
export const FetchNextActionStateFailure = createAction(FETCH_NEXT_ACTION_STATE_FAILURE);

/******** FETCH EXTERNAL TESTS ***********/
const FETCH_EXTERNAL_TESTS_REQUEST = '[projects] fetch external tests request';
export const FetchExternalTestsRequest = createAction(FETCH_EXTERNAL_TESTS_REQUEST, props<any>());

const FETCH_EXTERNAL_TESTS_SUCCESS = '[projects] fetch external tests success';
export const FetchExternalTestsSuccess = createAction(FETCH_EXTERNAL_TESTS_SUCCESS, props<any>());

const FETCH_EXTERNAL_TESTS_FAILURE = '[projects] fetch external tests failure';
export const FetchExternalTestsFailure = createAction(FETCH_EXTERNAL_TESTS_FAILURE);

/******** FETCH ISSUES ***********/
const FETCH_ISSUES_REQUEST = '[projects] fetch issues request';
export const FetchIssuesRequest = createAction(FETCH_ISSUES_REQUEST, props<any>());

const FETCH_ISSUES_SUCCESS = '[projects] fetch issues success';
export const FetchIssuesSuccess = createAction(FETCH_ISSUES_SUCCESS, props<any>());

const FETCH_ISSUES_FAILURE = '[projects] fetch issues failure';
export const FetchIssuesFailure = createAction(FETCH_ISSUES_FAILURE);

/******** DELETE VIDEO FROM MUX DB  ***********/
const DELETE_VIDEO_FROM_MUX_DB_REQUEST = '[projects] delete video from mux db request';
export const DeleteVideoFromMuxDbRequest = createAction(DELETE_VIDEO_FROM_MUX_DB_REQUEST, props<any>());

const DELETE_VIDEO_FROM_MUX_DB_SUCCESS = '[projects] delete video from mux db success';
export const DeleteVideoFromMuxDbSuccess = createAction(DELETE_VIDEO_FROM_MUX_DB_SUCCESS, props<any>());

const DELETE_VIDEO_FROM_MUX_DB_FAILURE = '[projects] delete video from mux db failure';
export const DeleteVideoFromMuxDbFailure = createAction(DELETE_VIDEO_FROM_MUX_DB_FAILURE);

/******** FETCH ACTIVITY IDS LIST ***********/
const FETCH_ACTIVITY_IDS_LIST_REQUEST = '[projects] fetch activity ids list request';
export const FetchActivityIdsListRequest = createAction(FETCH_ACTIVITY_IDS_LIST_REQUEST, props<any>());

const FETCH_ACTIVITY_IDS_LIST_SUCCESS = '[projects] fetch activity ids list success';
export const FetchActivityIdsListSuccess = createAction(FETCH_ACTIVITY_IDS_LIST_SUCCESS, props<any>());

const FETCH_ACTIVITY_IDS_LIST_FAILURE = '[projects] fetch activity ids list failure';
export const FetchActivityIdsListFailure = createAction(FETCH_ACTIVITY_IDS_LIST_FAILURE, props<any>());

/******** UPLOAD ACTIVITY IDS FILE ***********/
const UPLOAD_ACTIVITY_IDS_FILE_REQUEST = '[projects] upload activity ids file request';
export const UploadActivityIdsFileRequest = createAction(UPLOAD_ACTIVITY_IDS_FILE_REQUEST, props<any>());

const UPLOAD_ACTIVITY_IDS_FILE_SUCCESS = '[projects] upload activity ids file success';
export const UploadActivityIdsFileSuccess = createAction(UPLOAD_ACTIVITY_IDS_FILE_SUCCESS, props<any>());

const UPLOAD_ACTIVITY_IDS_FILE_FAILURE = '[projects] upload activity ids file failure';
export const UploadActivityIdsFileFailure = createAction(UPLOAD_ACTIVITY_IDS_FILE_FAILURE, props<any>());

/******** UPDATE ACTIVITY IDS DETAILS ***********/
const UPDATE_ACTIVITY_IDS_DETAILS_REQUEST = '[projects] update activity ids details request';
export const UpdateActivityIdsDetailsRequest = createAction(UPDATE_ACTIVITY_IDS_DETAILS_REQUEST, props<any>());

const UPDATE_ACTIVITY_IDS_DETAILS_SUCCESS = '[projects] update activity ids details success';
export const UpdateActivityIdsDetailsSuccess = createAction(UPDATE_ACTIVITY_IDS_DETAILS_SUCCESS, props<any>());

const UPDATE_ACTIVITY_IDS_DETAILS_FAILURE = '[projects] update activity ids details failure';
export const UpdateActivityIdsDetailsFailure = createAction(UPDATE_ACTIVITY_IDS_DETAILS_FAILURE, props<any>());

/******** DELETE ACTIVITY IDS DETAILS ***********/
const DELETE_ACTIVITY_IDS_DETAILS_REQUEST = '[projects] delete activity ids details request';
export const DeleteActivityIdsDetailsRequest = createAction(DELETE_ACTIVITY_IDS_DETAILS_REQUEST, props<any>());

const DELETE_ACTIVITY_IDS_DETAILS_SUCCESS = '[projects] delete activity ids details success';
export const DeleteActivityIdsDetailsSuccess = createAction(DELETE_ACTIVITY_IDS_DETAILS_SUCCESS, props<any>());

const DELETE_ACTIVITY_IDS_DETAILS_FAILURE = '[projects] delete activity ids details failure';
export const DeleteActivityIdsDetailsFailure = createAction(DELETE_ACTIVITY_IDS_DETAILS_FAILURE, props<any>());

/******** FETCH DAILY REPORT LINEAGE ***********/
const FETCH_DAILY_REPORT_LINEAGE_REQUEST = '[projects] fetch daily report lineage request';
export const FetchDailyReportLineageRequest = createAction(FETCH_DAILY_REPORT_LINEAGE_REQUEST, props<any>());

const FETCH_DAILY_REPORT_LINEAGE_SUCCESS = '[projects] fetch daily report lineage success';
export const FetchDailyReportLineageSuccess = createAction(FETCH_DAILY_REPORT_LINEAGE_SUCCESS, props<any>());

const FETCH_DAILY_REPORT_LINEAGE_FAILURE = '[projects] fetch daily report lineage failure';
export const FetchDailyReportLineageFailure = createAction(FETCH_DAILY_REPORT_LINEAGE_FAILURE);

/******** FETCH BASIS OF PAY OPTIONS ***********/
const FETCH_BASIS_OF_PAY_OPTIONS_REQUEST = '[projects] fetch basis of pay options request';
export const FetchBasisOfPayOptionsRequest = createAction(FETCH_BASIS_OF_PAY_OPTIONS_REQUEST, props<any>());

const FETCH_BASIS_OF_PAY_OPTIONS_SUCCESS = '[projects] fetch basis of pay options success';
export const FetchBasisOfPayOptionsSuccess = createAction(FETCH_BASIS_OF_PAY_OPTIONS_SUCCESS, props<any>());

const FETCH_BASIS_OF_PAY_OPTIONS_FAILURE = '[projects] fetch basis of pay options failure';
export const FetchBasisOfPayOptionsFailure = createAction(FETCH_BASIS_OF_PAY_OPTIONS_FAILURE);

/******** FETCH CHANGE IN WORK CODE OPTIONS ***********/
const FETCH_CHANGE_IN_WORK_CODE_OPTIONS_REQUEST = '[projects] fetch change in work code options request';
export const FetchChangeInWorkCodeOptionsRequest = createAction(
  FETCH_CHANGE_IN_WORK_CODE_OPTIONS_REQUEST,
  props<any>()
);

const FETCH_CHANGE_IN_WORK_CODE_OPTIONS_SUCCESS = '[projects] fetch change in work code options success';
export const FetchChangeInWorkCodeOptionsSuccess = createAction(
  FETCH_CHANGE_IN_WORK_CODE_OPTIONS_SUCCESS,
  props<any>()
);

const FETCH_CHANGE_IN_WORK_CODE_OPTIONS_FAILURE = '[projects] fetch change in work code options failure';
export const FetchChangeInWorkCodeOptionsFailure = createAction(FETCH_CHANGE_IN_WORK_CODE_OPTIONS_FAILURE);

/******** FETCH CHANGE IN WORK REQUEST LIST ***********/
const FETCH_CHANGE_IN_WORK_REQUEST_LIST_REQUEST = '[projects] fetch change in work request list request';
export const FetchChangeInWorkRequestListRequest = createAction(
  FETCH_CHANGE_IN_WORK_REQUEST_LIST_REQUEST,
  props<any>()
);

const FETCH_CHANGE_IN_WORK_REQUEST_LIST_SUCCESS = '[projects] fetch change in work request list success';
export const FetchChangeInWorkRequestListSuccess = createAction(
  FETCH_CHANGE_IN_WORK_REQUEST_LIST_SUCCESS,
  props<any>()
);

const FETCH_CHANGE_IN_WORK_REQUEST_LIST_FAILURE = '[projects] fetch change in work request list failure';
export const FetchChangeInWorkRequestListFailure = createAction(FETCH_CHANGE_IN_WORK_REQUEST_LIST_FAILURE);

/******** FETCH CHANGE ORDERS REQUEST LIST ***********/
const FETCH_CHANGE_ORDERS_REQUEST_LIST_REQUEST = '[projects] fetch change orders request list request';
export const FetchChangeOrdersRequestListRequest = createAction(FETCH_CHANGE_ORDERS_REQUEST_LIST_REQUEST, props<any>());

const FETCH_CHANGE_ORDERS_REQUEST_LIST_SUCCESS = '[projects] fetch change orders request list success';
export const FetchChangeOrdersRequestListSuccess = createAction(FETCH_CHANGE_ORDERS_REQUEST_LIST_SUCCESS, props<any>());

const FETCH_CHANGE_ORDERS_REQUEST_LIST_FAILURE = '[projects] fetch change orders request list failure';
export const FetchChangeOrdersRequestListFailure = createAction(FETCH_CHANGE_ORDERS_REQUEST_LIST_FAILURE);

/******** SAVE CHANGE IN WORK REQUEST ***********/
const SAVE_CHANGE_IN_WORK_REQUEST_REQUEST = '[projects] save change in work request request';
export const SaveChangeInWorkRequestRequest = createAction(SAVE_CHANGE_IN_WORK_REQUEST_REQUEST, props<any>());

const SAVE_CHANGE_IN_WORK_REQUEST_SUCCESS = '[projects] save change in work request success';
export const SaveChangeInWorkRequestSuccess = createAction(SAVE_CHANGE_IN_WORK_REQUEST_SUCCESS, props<any>());

const SAVE_CHANGE_IN_WORK_REQUEST_FAILURE = '[projects] save change in work request failure';
export const SaveChangeInWorkRequestFailure = createAction(SAVE_CHANGE_IN_WORK_REQUEST_FAILURE);

/******** SAVE CHANGE ORDERS REQUEST ***********/
const SAVE_CHANGE_ORDERS_REQUEST_REQUEST = '[projects] save change orders request request';
export const SaveChangeOrdersRequestRequest = createAction(SAVE_CHANGE_ORDERS_REQUEST_REQUEST, props<any>());

const SAVE_CHANGE_ORDERS_REQUEST_SUCCESS = '[projects] save change orders request success';
export const SaveChangeOrdersRequestSuccess = createAction(SAVE_CHANGE_ORDERS_REQUEST_SUCCESS, props<any>());

const SAVE_CHANGE_ORDERS_REQUEST_FAILURE = '[projects] save change orders request failure';
export const SaveChangeOrdersRequestFailure = createAction(SAVE_CHANGE_ORDERS_REQUEST_FAILURE);

/******** SEND CHANGE IN WORK REQUEST REMINDER ***********/
const SEND_CHANGE_IN_WORK_REQUEST_REMINDER_REQUEST = '[projects] send change in work request reminder request';
export const SendChangeInWorkRequestReminderRequest = createAction(
  SEND_CHANGE_IN_WORK_REQUEST_REMINDER_REQUEST,
  props<any>()
);

const SEND_CHANGE_IN_WORK_REQUEST_REMINDER_SUCCESS = '[projects] send change in work request reminder success';
export const SendChangeInWorkRequestReminderSuccess = createAction(
  SEND_CHANGE_IN_WORK_REQUEST_REMINDER_SUCCESS,
  props<any>()
);

const SEND_CHANGE_IN_WORK_REQUEST_REMINDER_FAILURE = '[projects] send change in work request reminder failure';
export const SendChangeInWorkRequestReminderFailure = createAction(
  SEND_CHANGE_IN_WORK_REQUEST_REMINDER_FAILURE,
  props<any>()
);

/******** SEND CHANGE ORDERS REQUEST REMINDER ***********/
const SEND_CHANGE_ORDERS_REQUEST_REMINDER_REQUEST = '[projects] send change orders request reminder request';
export const SendChangeOrdersRequestReminderRequest = createAction(
  SEND_CHANGE_ORDERS_REQUEST_REMINDER_REQUEST,
  props<any>()
);

const SEND_CHANGE_ORDERS_REQUEST_REMINDER_SUCCESS = '[projects] send change orders request reminder success';
export const SendChangeOrdersRequestReminderSuccess = createAction(
  SEND_CHANGE_ORDERS_REQUEST_REMINDER_SUCCESS,
  props<any>()
);

const SEND_CHANGE_ORDERS_REQUEST_REMINDER_FAILURE = '[projects] send change orders request reminder failure';
export const SendChangeOrdersRequestReminderFailure = createAction(
  SEND_CHANGE_ORDERS_REQUEST_REMINDER_FAILURE,
  props<any>()
);

/******** FETCH CHANGE IN WORK REQUEST WITH ID ***********/
const FETCH_CHANGE_IN_WORK_REQUEST_WITH_ID_REQUEST = '[projects] fetch change in work request with id request';
export const FetchChangeInWorkRequestWithIdRequest = createAction(
  FETCH_CHANGE_IN_WORK_REQUEST_WITH_ID_REQUEST,
  props<any>()
);

const FETCH_CHANGE_IN_WORK_REQUEST_WITH_ID_SUCCESS = '[projects] fetch change in work request with id success';
export const FetchChangeInWorkRequestWithIdSuccess = createAction(
  FETCH_CHANGE_IN_WORK_REQUEST_WITH_ID_SUCCESS,
  props<any>()
);

const FETCH_CHANGE_IN_WORK_REQUEST_WITH_ID_FAILURE = '[projects] fetch change in work request with id failure';
export const FetchChangeInWorkRequestWithIdFailure = createAction(FETCH_CHANGE_IN_WORK_REQUEST_WITH_ID_FAILURE);

/******** FETCH CHANGE ORDERS REQUEST WITH ID ***********/
const FETCH_CHANGE_ORDERS_REQUEST_WITH_ID_REQUEST = '[projects] fetch change orders request with id request';
export const FetchChangeOrdersRequestWithIdRequest = createAction(
  FETCH_CHANGE_ORDERS_REQUEST_WITH_ID_REQUEST,
  props<any>()
);

const FETCH_CHANGE_ORDERS_REQUEST_WITH_ID_SUCCESS = '[projects] fetch change orders request with id success';
export const FetchChangeOrdersRequestWithIdSuccess = createAction(
  FETCH_CHANGE_ORDERS_REQUEST_WITH_ID_SUCCESS,
  props<any>()
);

const FETCH_CHANGE_ORDERS_REQUEST_WITH_ID_FAILURE = '[projects] fetch change orders request with id failure';
export const FetchChangeOrdersRequestWithIdFailure = createAction(FETCH_CHANGE_ORDERS_REQUEST_WITH_ID_FAILURE);

/******** EXECUTE WORKFLOW ACTION STATE ***********/
const EXECUTE_WORKFLOW_ACTION_STATE_REQUEST = '[projects] execute workflow action state request';
export const ExecuteWorkflowActionStateRequest = createAction(EXECUTE_WORKFLOW_ACTION_STATE_REQUEST, props<any>());

const EXECUTE_WORKFLOW_ACTION_STATE_SUCCESS = '[projects] execute workflow action state success';
export const ExecuteWorkflowActionStateSuccess = createAction(EXECUTE_WORKFLOW_ACTION_STATE_SUCCESS, props<any>());

const EXECUTE_WORKFLOW_ACTION_STATE_FAILURE = '[projects] execute workflow action state failure';
export const ExecuteWorkflowActionStateFailure = createAction(EXECUTE_WORKFLOW_ACTION_STATE_FAILURE);

/******** FETCH LINEAGE ***********/
const FETCH_LINEAGE_REQUEST = '[projects] fetch lineage request';
export const FetchLineageRequest = createAction(FETCH_LINEAGE_REQUEST, props<any>());

const FETCH_LINEAGE_SUCCESS = '[projects] fetch lineage success';
export const FetchLineageSuccess = createAction(FETCH_LINEAGE_SUCCESS, props<any>());

const FETCH_LINEAGE_FAILURE = '[projects] fetch lineage failure';
export const FetchLineageFailure = createAction(FETCH_LINEAGE_FAILURE);

/******** FETCH REPORT ***********/
const FETCH_REPORT_REQUEST = '[projects] fetch report request';
export const FetchReportRequest = createAction(FETCH_REPORT_REQUEST, props<any>());

const FETCH_REPORT_SUCCESS = '[projects] fetch report success';
export const FetchReportSuccess = createAction(FETCH_REPORT_SUCCESS, props<any>());

const FETCH_REPORT_FAILURE = '[projects] fetch report failure';
export const FetchReportFailure = createAction(FETCH_REPORT_FAILURE);

/******** DOWNLOAD REPORT ***********/
const DOWNLOAD_REPORT_REQUEST = '[projects] download report request';
export const DownloadReportRequest = createAction(DOWNLOAD_REPORT_REQUEST, props<any>());

const DOWNLOAD_REPORT_SUCCESS = '[projects] download report success';
export const DownloadReportSuccess = createAction(DOWNLOAD_REPORT_SUCCESS, props<any>());

const DOWNLOAD_REPORT_FAILURE = '[projects] download report failure';
export const DownloadReportFailure = createAction(DOWNLOAD_REPORT_FAILURE);

/******** DELETE DAILY REPORT ***********/
const DELETE_DAILY_REPORT_REQUEST = '[projects] delete daily report request';
export const DeleteDailyReportRequest = createAction(DELETE_DAILY_REPORT_REQUEST, props<any>());

const DELETE_DAILY_REPORT_SUCCESS = '[projects] delete daily report success';
export const DeleteDailyReportSuccess = createAction(DELETE_DAILY_REPORT_SUCCESS, props<any>());

const DELETE_DAILY_REPORT_FAILURE = '[projects] delete daily report failure';
export const DeleteDailyReportFailure = createAction(DELETE_DAILY_REPORT_FAILURE, props<any>());

/******** DELETE CIWR ***********/
const DELETE_CIWR_REQUEST = '[projects] delete ciwr request';
export const DeleteCIWRRequest = createAction(DELETE_CIWR_REQUEST, props<any>());

const DELETE_CIWR_SUCCESS = '[projects] delete ciwr success';
export const DeleteCIWRSuccess = createAction(DELETE_CIWR_SUCCESS, props<any>());

const DELETE_CIWR_FAILURE = '[projects] delete ciwr failure';
export const DeleteCIWRFailure = createAction(DELETE_CIWR_FAILURE);

/******** CREATE SUBMITTALS REGISTRY ITEM ***********/
const CREATE_SUBMITTALS_REGISTRY_ITEM_REQUEST = '[projects] create submittals registry item request';
export const CreateSubmittalsRegistryItemRequest = createAction(CREATE_SUBMITTALS_REGISTRY_ITEM_REQUEST, props<any>());

const CREATE_SUBMITTALS_REGISTRY_ITEM_SUCCESS = '[projects] create submittals registry item success';
export const CreateSubmittalsRegistryItemSuccess = createAction(CREATE_SUBMITTALS_REGISTRY_ITEM_SUCCESS, props<any>());

const CREATE_SUBMITTALS_REGISTRY_ITEM_FAILURE = '[projects] create submittals registry item failure';
export const CreateSubmittalsRegistryItemFailure = createAction(CREATE_SUBMITTALS_REGISTRY_ITEM_FAILURE);

/******** CREATE SUBMITTALS ITEM ***********/
const CREATE_SUBMITTALS_ITEM_REQUEST = '[projects] create submittals item request';
export const CreateSubmittalsItemRequest = createAction(CREATE_SUBMITTALS_ITEM_REQUEST, props<any>());

const CREATE_SUBMITTALS_ITEM_SUCCESS = '[projects] create submittals item success';
export const CreateSubmittalsItemSuccess = createAction(CREATE_SUBMITTALS_ITEM_SUCCESS, props<any>());

const CREATE_SUBMITTALS_ITEM_FAILURE = '[projects] create submittals item failure';
export const CreateSubmittalsItemFailure = createAction(CREATE_SUBMITTALS_ITEM_FAILURE);

/******** FETCH SUBMITTALS REGISTRY LIST ***********/
const FETCH_SUBMITTALS_REGISTRY_LIST_REQUEST = '[projects] fetch submittals registry list request';
export const FetchSubmittalsRegistryListRequest = createAction(FETCH_SUBMITTALS_REGISTRY_LIST_REQUEST, props<any>());

const FETCH_SUBMITTALS_REGISTRY_LIST_SUCCESS = '[projects] fetch submittals registry list success';
export const FetchSubmittalsRegistryListSuccess = createAction(FETCH_SUBMITTALS_REGISTRY_LIST_SUCCESS, props<any>());

const FETCH_SUBMITTALS_REGISTRY_LIST_FAILURE = '[projects] fetch submittals registry list failure';
export const FetchSubmittalsRegistryListFailure = createAction(FETCH_SUBMITTALS_REGISTRY_LIST_FAILURE);

/******** FETCH SUBMITTALS ITEMS LIST ***********/
const FETCH_SUBMITTALS_ITEMS_LIST_REQUEST = '[projects] fetch submittals items list request';
export const FetchSubmittalsItemsListRequest = createAction(FETCH_SUBMITTALS_ITEMS_LIST_REQUEST, props<any>());

const FETCH_SUBMITTALS_ITEMS_LIST_SUCCESS = '[projects] fetch submittals items list success';
export const FetchSubmittalsItemsListSuccess = createAction(FETCH_SUBMITTALS_ITEMS_LIST_SUCCESS, props<any>());

const FETCH_SUBMITTALS_ITEMS_LIST_FAILURE = '[projects] fetch submittals items list failure';
export const FetchSubmittalsItemsListFailure = createAction(FETCH_SUBMITTALS_ITEMS_LIST_FAILURE);

/******** FETCH USERS LIST ***********/
const FETCH_USERS_LIST_REQUEST = '[projects] fetch users list request';
export const FetchUsersListRequest = createAction(FETCH_USERS_LIST_REQUEST, props<any>());

const FETCH_USERS_LIST_SUCCESS = '[projects] fetch users list success';
export const FetchUsersListSuccess = createAction(FETCH_USERS_LIST_SUCCESS, props<any>());

const FETCH_USERS_LIST_FAILURE = '[projects] fetch users list failure';
export const FetchUsersListFailure = createAction(FETCH_USERS_LIST_FAILURE);

/******** FETCH PROJECT ROLES LIST ***********/
const FETCH_PROJECT_ROLES_LIST_REQUEST = '[projects] fetch project roles list request';
export const FetchProjectRolesListRequest = createAction(FETCH_PROJECT_ROLES_LIST_REQUEST, props<any>());

const FETCH_PROJECT_ROLES_LIST_SUCCESS = '[projects] fetch project roles list success';
export const FetchProjectRolesListSuccess = createAction(FETCH_PROJECT_ROLES_LIST_SUCCESS, props<any>());

const FETCH_PROJECT_ROLES_LIST_FAILURE = '[projects] fetch project roles list failure';
export const FetchProjectRolesListFailure = createAction(FETCH_PROJECT_ROLES_LIST_FAILURE);

/******** FETCH SUBMITTALS ITEM DETAILS WITH ID ***********/
const FETCH_SUBMITTALS_ITEM_DETAILS_WITH_ID_REQUEST = '[projects] fetch submittals item details with id request';
export const FetchSubmittalsItemDetailsWithIdRequest = createAction(
  FETCH_SUBMITTALS_ITEM_DETAILS_WITH_ID_REQUEST,
  props<any>()
);

const FETCH_SUBMITTALS_ITEM_DETAILS_WITH_ID_SUCCESS = '[projects] fetch submittals item details with id success';
export const FetchSubmittalsItemDetailsWithIdSuccess = createAction(
  FETCH_SUBMITTALS_ITEM_DETAILS_WITH_ID_SUCCESS,
  props<any>()
);

const FETCH_SUBMITTALS_ITEM_DETAILS_WITH_ID_FAILURE = '[projects] fetch submittals item details with id failure';
export const FetchSubmittalsItemDetailsWithIdFailure = createAction(FETCH_SUBMITTALS_ITEM_DETAILS_WITH_ID_FAILURE);

/******** SUBMIT REVIEWERS  ***********/
const SUBMIT_REVIEWERS_REQUEST = '[projects] submit reviewers request';
export const SubmitReviewersRequest = createAction(SUBMIT_REVIEWERS_REQUEST, props<any>());

const SUBMIT_REVIEWERS_SUCCESS = '[projects] submit reviewers success';
export const SubmitReviewersSuccess = createAction(SUBMIT_REVIEWERS_SUCCESS, props<any>());

const SUBMIT_REVIEWERS_FAILURE = '[projects] submit reviewers failure';
export const SubmitReviewersFailure = createAction(SUBMIT_REVIEWERS_FAILURE);

/******** SUBMIT RFI REVIEWERS  ***********/
const SUBMIT_RFI_REVIEWERS_REQUEST = '[projects] submit rfi reviewers request';
export const SubmitRfiReviewersRequest = createAction(SUBMIT_RFI_REVIEWERS_REQUEST, props<any>());

const SUBMIT_RFI_REVIEWERS_SUCCESS = '[projects] submit rfi reviewers success';
export const SubmitRfiReviewersSuccess = createAction(SUBMIT_RFI_REVIEWERS_SUCCESS, props<any>());

const SUBMIT_RFI_REVIEWERS_FAILURE = '[projects] submit rfi reviewers failure';
export const SubmitRfiReviewersFailure = createAction(SUBMIT_RFI_REVIEWERS_FAILURE);

/******** EXECUTE SUBMIT WORKFLOW  ***********/
const EXECUTE_SUBMIT_WORKFLOW_REQUEST = '[projects] execute submit workFlow request';
export const ExecuteSubmitWorkFlowRequest = createAction(EXECUTE_SUBMIT_WORKFLOW_REQUEST, props<any>());

const EXECUTE_SUBMIT_WORKFLOW_SUCCESS = '[projects] execute submit workFlow success';
export const ExecuteSubmitWorkFlowSuccess = createAction(EXECUTE_SUBMIT_WORKFLOW_SUCCESS, props<any>());

const EXECUTE_SUBMIT_WORKFLOW_FAILURE = '[projects] execute submit workFlow failure';
export const ExecuteSubmitWorkFlowFailure = createAction(EXECUTE_SUBMIT_WORKFLOW_FAILURE);

/******** EXECUTE SUBMIT RFI WORKFLOW  ***********/
const EXECUTE_SUBMIT_RFI_WORKFLOW_REQUEST = '[projects] execute submit rfi workFlow request';
export const ExecuteSubmitRFIWorkFlowRequest = createAction(EXECUTE_SUBMIT_RFI_WORKFLOW_REQUEST, props<any>());

const EXECUTE_SUBMIT_RFI_WORKFLOW_SUCCESS = '[projects] execute submit rfi workFlow success';
export const ExecuteSubmitRFIWorkFlowSuccess = createAction(EXECUTE_SUBMIT_RFI_WORKFLOW_SUCCESS, props<any>());

const EXECUTE_SUBMIT_RFI_WORKFLOW_FAILURE = '[projects] execute submit rfi workFlow failure';
export const ExecuteSubmitRFIWorkFlowFailure = createAction(EXECUTE_SUBMIT_RFI_WORKFLOW_FAILURE);

/******** UPLOAD SUBMITTAL LOG FILE ***********/
const UPLOAD_SUBMITTAL_LOG_FILE_REQUEST = '[projects] upload submittal log file request';
export const UploadSubmittalLogFileRequest = createAction(UPLOAD_SUBMITTAL_LOG_FILE_REQUEST, props<any>());

const UPLOAD_SUBMITTAL_LOG_FILE_SUCCESS = '[projects] upload submittal log file success';
export const UploadSubmittalLogFileSuccess = createAction(UPLOAD_SUBMITTAL_LOG_FILE_SUCCESS, props<any>());

const UPLOAD_SUBMITTAL_LOG_FILE_FAILURE = '[projects] upload submittal log file failure';
export const UploadSubmittalLogFileFailure = createAction(UPLOAD_SUBMITTAL_LOG_FILE_FAILURE, props<any>());

/******** FETCH RFI NO ***********/
const FETCH_RFI_NO_REQUEST = '[projects] fetch rfi no request';
export const FetchRFINoRequest = createAction(FETCH_RFI_NO_REQUEST, props<any>());

const FETCH_RFI_NO_SUCCESS = '[projects] fetch rfi no success';
export const FetchRFINoSuccess = createAction(FETCH_RFI_NO_SUCCESS, props<any>());

const FETCH_RFI_NO_FAILURE = '[projects] fetch rfi no failure';
export const FetchRFINoFailure = createAction(FETCH_RFI_NO_FAILURE);

/******** FETCH RFIS LIST ***********/
const FETCH_RFIS_LIST_REQUEST = '[projects] fetch rfis list request';
export const FetchRFIsListRequest = createAction(FETCH_RFIS_LIST_REQUEST, props<any>());

const FETCH_RFIS_LIST_SUCCESS = '[projects] fetch rfis list success';
export const FetchRFIsListSuccess = createAction(FETCH_RFIS_LIST_SUCCESS, props<any>());

const FETCH_RFIS_LIST_FAILURE = '[projects] fetch rfis list failure';
export const FetchRFIsListFailure = createAction(FETCH_RFIS_LIST_FAILURE);

/******** FETCH PROJECT MEMBERS LIST ***********/
const FETCH_PROJECT_MEMBERS_LIST_REQUEST = '[projects] fetch project members list request';
export const FetchProjectMembersListRequest = createAction(FETCH_PROJECT_MEMBERS_LIST_REQUEST, props<any>());

const FETCH_PROJECT_MEMBERS_LIST_SUCCESS = '[projects] fetch project members list success';
export const FetchProjectMembersListSuccess = createAction(FETCH_PROJECT_MEMBERS_LIST_SUCCESS, props<any>());

const FETCH_PROJECT_MEMBERS_LIST_FAILURE = '[projects] fetch project members list failure';
export const FetchProjectMembersListFailure = createAction(FETCH_PROJECT_MEMBERS_LIST_FAILURE);

/******** FETCH CONTRACTORS LIST ***********/
const FETCH_CONTRACTORS_LIST_REQUEST = '[projects] fetch contractors list request';
export const FetchContractorsListRequest = createAction(FETCH_CONTRACTORS_LIST_REQUEST, props<any>());

const FETCH_CONTRACTORS_LIST_SUCCESS = '[projects] fetch contractors list success';
export const FetchContractorsListSuccess = createAction(FETCH_CONTRACTORS_LIST_SUCCESS, props<any>());

const FETCH_CONTRACTORS_LIST_FAILURE = '[projects] fetch contractors list failure';
export const FetchContractorsListFailure = createAction(FETCH_CONTRACTORS_LIST_FAILURE);

/******** CREATE CONTRACTOR ***********/
const CREATE_CONTRACTOR_REQUEST = '[projects] create contractor request';
export const CreateContractorRequest = createAction(CREATE_CONTRACTOR_REQUEST, props<any>());

const CREATE_CONTRACTOR_SUCCESS = '[projects] create contractor success';
export const CreateContractorSuccess = createAction(CREATE_CONTRACTOR_SUCCESS, props<any>());

const CREATE_CONTRACTOR_FAILURE = '[projects] create contractor failure';
export const CreateContractorFailure = createAction(CREATE_CONTRACTOR_FAILURE);

/******** UPDATE CONTRACTOR ***********/
const UPDATE_CONTRACTOR_REQUEST = '[projects] update contractor request';
export const UpdateContractorRequest = createAction(UPDATE_CONTRACTOR_REQUEST, props<any>());

const UPDATE_CONTRACTOR_SUCCESS = '[projects] update contractor success';
export const UpdateContractorSuccess = createAction(UPDATE_CONTRACTOR_SUCCESS, props<any>());

const UPDATE_CONTRACTOR_FAILURE = '[projects] update contractor failure';
export const UpdateContractorFailure = createAction(UPDATE_CONTRACTOR_FAILURE);

/******** DELETE CONTRACTOR ***********/
const DELETE_CONTRACTOR_REQUEST = '[projects] delete contractor request';
export const DeleteContractorRequest = createAction(DELETE_CONTRACTOR_REQUEST, props<any>());

/******** FETCH SITES LIST ***********/
const FETCH_SITES_LIST_REQUEST = '[projects] fetch sites list request';
export const FetchSitesListRequest = createAction(FETCH_SITES_LIST_REQUEST, props<any>());

const FETCH_SITES_LIST_SUCCESS = '[projects] fetch sites list success';
export const FetchSitesListSuccess = createAction(FETCH_SITES_LIST_SUCCESS, props<any>());

const FETCH_SITES_LIST_FAILURE = '[projects] fetch sites list failure';
export const FetchSitesListFailure = createAction(FETCH_SITES_LIST_FAILURE);

/******** DELETE SITE ***********/
const DELETE_SITE_REQUEST = '[projects] delete site request';
export const DeleteSiteRequest = createAction(DELETE_SITE_REQUEST, props<any>());

const DELETE_SITE_SUCCESS = '[projects] delete site success';
export const DeleteSiteSuccess = createAction(DELETE_SITE_SUCCESS, props<any>());

const DELETE_SITE_FAILURE = '[projects] delete site failure';
export const DeleteSiteFailure = createAction(DELETE_SITE_FAILURE);

/******** CREATE SITE ***********/
const CREATE_SITE_REQUEST = '[projects] create site request';
export const CreateSiteRequest = createAction(CREATE_SITE_REQUEST, props<any>());

const CREATE_SITE_SUCCESS = '[projects] create site success';
export const CreateSiteSuccess = createAction(CREATE_SITE_SUCCESS, props<any>());

const CREATE_SITE_FAILURE = '[projects] create site failure';
export const CreateSiteFailure = createAction(CREATE_SITE_FAILURE);

/******** UPDATE SITE ***********/
const UPDATE_SITE_REQUEST = '[projects] update site request';
export const UpdateSiteRequest = createAction(UPDATE_SITE_REQUEST, props<any>());

const UPDATE_SITE_SUCCESS = '[projects] update site success';
export const UpdateSiteSuccess = createAction(UPDATE_SITE_SUCCESS, props<any>());

const UPDATE_SITE_FAILURE = '[projects] update site failure';
export const UpdateSiteFailure = createAction(UPDATE_SITE_FAILURE);

const DELETE_CONTRACTOR_SUCCESS = '[projects] delete contractor success';
export const DeleteContractorSuccess = createAction(DELETE_CONTRACTOR_SUCCESS, props<any>());

const DELETE_CONTRACTOR_FAILURE = '[projects] delete contractor failure';
export const DeleteContractorFailure = createAction(DELETE_CONTRACTOR_FAILURE);

/******** FETCH DELIVERY TRACKING FIELDS ***********/
const FETCH_DELIVERY_TRACKING_FIELDS_REQUEST = '[projects] fetch delivery tracking fields request';
export const FetchDeliveryTrackingFieldsRequest = createAction(
  FETCH_DELIVERY_TRACKING_FIELDS_REQUEST,
  props<{ payload: { projectId: string } }>()
);

const FETCH_DELIVERY_TRACKING_FIELDS_SUCCESS = '[projects] fetch delivery tracking fields success';
export const FetchDeliveryTrackingFieldsSuccess = createAction(
  FETCH_DELIVERY_TRACKING_FIELDS_SUCCESS,
  props<{ deliveryTrackingFieldsListInfo: { list: any[]; totalRecords: number } }>()
);

const FETCH_DELIVERY_TRACKING_FIELDS_FAILURE = '[projects] fetch delivery tracking fields failure';
export const FetchDeliveryTrackingFieldsFailure = createAction(FETCH_DELIVERY_TRACKING_FIELDS_FAILURE);

/******** CREATE DELIVERY TRACKING FIELD ***********/
const CREATE_DELIVERY_TRACKING_FIELD_REQUEST = '[projects] create delivery tracking field request';
export const CreateDeliveryTrackingFieldRequest = createAction(
  CREATE_DELIVERY_TRACKING_FIELD_REQUEST,
  props<{ payload: any }>()
);

const CREATE_DELIVERY_TRACKING_FIELD_SUCCESS = '[projects] create delivery tracking field success';
export const CreateDeliveryTrackingFieldSuccess = createAction(
  CREATE_DELIVERY_TRACKING_FIELD_SUCCESS,
  props<any>()
);

const CREATE_DELIVERY_TRACKING_FIELD_FAILURE = '[projects] create delivery tracking field failure';
export const CreateDeliveryTrackingFieldFailure = createAction(CREATE_DELIVERY_TRACKING_FIELD_FAILURE);

/******** UPDATE DELIVERY TRACKING FIELD ***********/
const UPDATE_DELIVERY_TRACKING_FIELD_REQUEST = '[projects] update delivery tracking field request';
export const UpdateDeliveryTrackingFieldRequest = createAction(
  UPDATE_DELIVERY_TRACKING_FIELD_REQUEST,
  props<{ payload: any }>()
);

const UPDATE_DELIVERY_TRACKING_FIELD_SUCCESS = '[projects] update delivery tracking field success';
export const UpdateDeliveryTrackingFieldSuccess = createAction(
  UPDATE_DELIVERY_TRACKING_FIELD_SUCCESS,
  props<any>()
);

const UPDATE_DELIVERY_TRACKING_FIELD_FAILURE = '[projects] update delivery tracking field failure';
export const UpdateDeliveryTrackingFieldFailure = createAction(UPDATE_DELIVERY_TRACKING_FIELD_FAILURE);

/******** DELETE DELIVERY TRACKING FIELD ***********/
const DELETE_DELIVERY_TRACKING_FIELD_REQUEST = '[projects] delete delivery tracking field request';
export const DeleteDeliveryTrackingFieldRequest = createAction(
  DELETE_DELIVERY_TRACKING_FIELD_REQUEST,
  props<{ payload: any }>()
);

const DELETE_DELIVERY_TRACKING_FIELD_SUCCESS = '[projects] delete delivery tracking field success';
export const DeleteDeliveryTrackingFieldSuccess = createAction(
  DELETE_DELIVERY_TRACKING_FIELD_SUCCESS,
  props<any>()
);

const DELETE_DELIVERY_TRACKING_FIELD_FAILURE = '[projects] delete delivery tracking field failure';
export const DeleteDeliveryTrackingFieldFailure = createAction(DELETE_DELIVERY_TRACKING_FIELD_FAILURE);

/******** FETCH EXISTING MEMBERS LIST ***********/
const FETCH_EXISTING_MEMBERS_LIST_REQUEST = '[projects] fetch existing members list request';
export const FetchExistingMembersListRequest = createAction(FETCH_EXISTING_MEMBERS_LIST_REQUEST, props<any>());

const FETCH_EXISTING_MEMBERS_LIST_SUCCESS = '[projects] fetch existing members list success';
export const FetchExistingMembersListSuccess = createAction(FETCH_EXISTING_MEMBERS_LIST_SUCCESS, props<any>());

const FETCH_EXISTING_MEMBERS_LIST_FAILURE = '[projects] fetch existing members list failure';
export const FetchExistingMembersListFailure = createAction(FETCH_EXISTING_MEMBERS_LIST_FAILURE);

/******** INVITE USER ***********/
const INVITE_USER_REQUEST = '[projects] invite user request';
export const InviteUserRequest = createAction(INVITE_USER_REQUEST, props<any>());

const INVITE_USER_SUCCESS = '[projects] invite user success';
export const InviteUserSuccess = createAction(INVITE_USER_SUCCESS, props<any>());

const INVITE_USER_FAILURE = '[projects] invite user failure';
export const InviteUserFailure = createAction(INVITE_USER_FAILURE);

/******** UPDATE USER ***********/
const UPDATE_USER_REQUEST = '[projects] update user request';
export const UpdateUserRequest = createAction(UPDATE_USER_REQUEST, props<any>());

const UPDATE_USER_SUCCESS = '[projects] update user success';
export const UpdateUserSuccess = createAction(UPDATE_USER_SUCCESS, props<any>());

const UPDATE_USER_FAILURE = '[projects] update user failure';
export const UpdateUserFailure = createAction(UPDATE_USER_FAILURE);

/******** DELETE USER ***********/
const DELETE_USER_REQUEST = '[projects] delete user request';
export const DeleteUserRequest = createAction(DELETE_USER_REQUEST, props<any>());

const DELETE_USER_SUCCESS = '[projects] delete user success';
export const DeleteUserSuccess = createAction(DELETE_USER_SUCCESS, props<any>());

const DELETE_USER_FAILURE = '[projects] delete user failure';
export const DeleteUserFailure = createAction(DELETE_USER_FAILURE);

/******** FETCH RFI ITEM DETAILS WITH ID ***********/
const FETCH_RFI_ITEM_DETAILS_WITH_ID_REQUEST = '[projects] fetch rfi details with id request';
export const FetchRFIItemDetailsWithIdRequest = createAction(FETCH_RFI_ITEM_DETAILS_WITH_ID_REQUEST, props<any>());

const FETCH_RFI_ITEM_DETAILS_WITH_ID_SUCCESS = '[projects] fetch rfi details with id success';
export const FetchRFIItemDetailsWithIdSuccess = createAction(FETCH_RFI_ITEM_DETAILS_WITH_ID_SUCCESS, props<any>());

const FETCH_RFI_ITEM_DETAILS_WITH_ID_FAILURE = '[projects] fetch rfi details with id failure';
export const FetchRFIItemDetailsWithIdFailure = createAction(FETCH_RFI_ITEM_DETAILS_WITH_ID_FAILURE);

/******** CREATE RFI ***********/
const CREATE_RFI_REQUEST = '[projects] create rfi request';
export const CreateRFIRequest = createAction(CREATE_RFI_REQUEST, props<any>());

const CREATE_RFI_SUCCESS = '[projects] create rfi success';
export const CreateRFISuccess = createAction(CREATE_RFI_SUCCESS, props<any>());

const CREATE_RFI_FAILURE = '[projects] create rfi failure';
export const CreateRFIFailure = createAction(CREATE_RFI_FAILURE);

/******** FETCH LABOR LOOKUP ***********/
const FETCH_LABOR_LOOKUP_REQUEST = '[projects] fetch labor lookup request';
export const FetchLaborLookupRequest = createAction(FETCH_LABOR_LOOKUP_REQUEST, props<any>());

const FETCH_LABOR_LOOKUP_SUCCESS = '[projects] fetch labor lookup success';
export const FetchLaborLookupSuccess = createAction(FETCH_LABOR_LOOKUP_SUCCESS, props<any>());

const FETCH_LABOR_LOOKUP_FAILURE = '[projects] fetch labor lookup failure';
export const FetchLaborLookupFailure = createAction(FETCH_LABOR_LOOKUP_FAILURE);

/******** CREATE LABOR LOOKUP ***********/
const CREATE_LABOR_LOOKUP_REQUEST = '[projects] create labor lookup request';
export const CreateLaborLookupRequest = createAction(CREATE_LABOR_LOOKUP_REQUEST, props<any>());

const CREATE_LABOR_LOOKUP_SUCCESS = '[projects] create labor lookup success';
export const CreateLaborLookupSuccess = createAction(CREATE_LABOR_LOOKUP_SUCCESS, props<any>());

const CREATE_LABOR_LOOKUP_FAILURE = '[projects] create labor lookup failure';
export const CreateLaborLookupFailure = createAction(CREATE_LABOR_LOOKUP_FAILURE);

/******** DELETE LABOR LOOKUP ***********/
const DELETE_LABOR_LOOKUP_REQUEST = '[projects] delete labor lookup request';
export const DeleteLaborLookupRequest = createAction(DELETE_LABOR_LOOKUP_REQUEST, props<any>());

const DELETE_LABOR_LOOKUP_SUCCESS = '[projects] delete labor lookup success';
export const DeleteLaborLookupSuccess = createAction(DELETE_LABOR_LOOKUP_SUCCESS, props<any>());

const DELETE_LABOR_LOOKUP_FAILURE = '[projects] delete labor lookup failure';
export const DeleteLaborLookupFailure = createAction(DELETE_LABOR_LOOKUP_FAILURE);

/******** FETCH EQUIPMENT LOOKUP ***********/
const FETCH_EQUIPMENT_LOOKUP_REQUEST = '[projects] fetch equipment lookup request';
export const FetchEquipmentLookupRequest = createAction(FETCH_EQUIPMENT_LOOKUP_REQUEST, props<any>());

const FETCH_EQUIPMENT_LOOKUP_SUCCESS = '[projects] fetch equipment lookup success';
export const FetchEquipmentLookupSuccess = createAction(FETCH_EQUIPMENT_LOOKUP_SUCCESS, props<any>());

const FETCH_EQUIPMENT_LOOKUP_FAILURE = '[projects] fetch equipment lookup failure';
export const FetchEquipmentLookupFailure = createAction(FETCH_EQUIPMENT_LOOKUP_FAILURE);

/******** CREATE EQUIPMENT LOOKUP ***********/
const CREATE_EQUIPMENT_LOOKUP_REQUEST = '[projects] create equipment lookup request';
export const CreateEquipmentLookupRequest = createAction(CREATE_EQUIPMENT_LOOKUP_REQUEST, props<any>());

const CREATE_EQUIPMENT_LOOKUP_SUCCESS = '[projects] create equipment lookup success';
export const CreateEquipmentLookupSuccess = createAction(CREATE_EQUIPMENT_LOOKUP_SUCCESS, props<any>());

const CREATE_EQUIPMENT_LOOKUP_FAILURE = '[projects] create equipment lookup failure';
export const CreateEquipmentLookupFailure = createAction(CREATE_EQUIPMENT_LOOKUP_FAILURE);

/******** DELETE EQUIPMENT LOOKUP ***********/
const DELETE_EQUIPMENT_LOOKUP_REQUEST = '[projects] delete equipment lookup request';
export const DeleteEquipmentLookupRequest = createAction(DELETE_EQUIPMENT_LOOKUP_REQUEST, props<any>());

const DELETE_EQUIPMENT_LOOKUP_SUCCESS = '[projects] delete equipment lookup success';
export const DeleteEquipmentLookupSuccess = createAction(DELETE_EQUIPMENT_LOOKUP_SUCCESS, props<any>());

const DELETE_EQUIPMENT_LOOKUP_FAILURE = '[projects] delete equipment lookup failure';
export const DeleteEquipmentLookupFailure = createAction(DELETE_EQUIPMENT_LOOKUP_FAILURE);

/******** FETCH ACTIVITY TYPE LOOKUP ***********/
const FETCH_ACTIVITY_TYPE_LOOKUP_REQUEST = '[projects] fetch activity type lookup request';
export const FetchActivityTypeLookupRequest = createAction(FETCH_ACTIVITY_TYPE_LOOKUP_REQUEST, props<any>());

const FETCH_ACTIVITY_TYPE_LOOKUP_SUCCESS = '[projects] fetch activity type lookup success';
export const FetchActivityTypeLookupSuccess = createAction(FETCH_ACTIVITY_TYPE_LOOKUP_SUCCESS, props<any>());

const FETCH_ACTIVITY_TYPE_LOOKUP_FAILURE = '[projects] fetch activity type lookup failure';
export const FetchActivityTypeLookupFailure = createAction(FETCH_ACTIVITY_TYPE_LOOKUP_FAILURE);

/******** CREATE ACTIVITY TYPE LOOKUP ***********/
const CREATE_ACTIVITY_TYPE_LOOKUP_REQUEST = '[projects] create activity type lookup request';
export const CreateActivityTypeLookupRequest = createAction(CREATE_ACTIVITY_TYPE_LOOKUP_REQUEST, props<any>());

const CREATE_ACTIVITY_TYPE_LOOKUP_SUCCESS = '[projects] create activity type lookup success';
export const CreateActivityTypeLookupSuccess = createAction(CREATE_ACTIVITY_TYPE_LOOKUP_SUCCESS, props<any>());

const CREATE_ACTIVITY_TYPE_LOOKUP_FAILURE = '[projects] create activity type lookup failure';
export const CreateActivityTypeLookupFailure = createAction(CREATE_ACTIVITY_TYPE_LOOKUP_FAILURE);

/******** DELETE ACTIVITY TYPE LOOKUP ***********/
const DELETE_ACTIVITY_TYPE_LOOKUP_REQUEST = '[projects] delete activity type lookup request';
export const DeleteActivityTypeLookupRequest = createAction(DELETE_ACTIVITY_TYPE_LOOKUP_REQUEST, props<any>());

const DELETE_ACTIVITY_TYPE_LOOKUP_SUCCESS = '[projects] delete activity type lookup success';
export const DeleteActivityTypeLookupSuccess = createAction(DELETE_ACTIVITY_TYPE_LOOKUP_SUCCESS, props<any>());

const DELETE_ACTIVITY_TYPE_LOOKUP_FAILURE = '[projects] delete activity type lookup failure';
export const DeleteActivityTypeLookupFailure = createAction(DELETE_ACTIVITY_TYPE_LOOKUP_FAILURE);

/******** FETCH EXTERNAL LAB LOOKUP ***********/
const FETCH_EXTERNAL_LAB_LOOKUP_REQUEST = '[projects] fetch external lab lookup request';
export const FetchExternalLabLookupRequest = createAction(FETCH_EXTERNAL_LAB_LOOKUP_REQUEST, props<any>());

const FETCH_EXTERNAL_LAB_LOOKUP_SUCCESS = '[projects] fetch external lab lookup success';
export const FetchExternalLabLookupSuccess = createAction(FETCH_EXTERNAL_LAB_LOOKUP_SUCCESS, props<any>());

const FETCH_EXTERNAL_LAB_LOOKUP_FAILURE = '[projects] fetch external lab lookup failure';
export const FetchExternalLabLookupFailure = createAction(FETCH_EXTERNAL_LAB_LOOKUP_FAILURE);

/******** CREATE EXTERNAL LAB ***********/
const CREATE_EXTERNAL_LAB_REQUEST = '[projects] create external lab request';
export const CreateExternalLabRequest = createAction(CREATE_EXTERNAL_LAB_REQUEST, props<any>());

const CREATE_EXTERNAL_LAB_SUCCESS = '[projects] create external lab success';
export const CreateExternalLabSuccess = createAction(CREATE_EXTERNAL_LAB_SUCCESS, props<any>());

const CREATE_EXTERNAL_LAB_FAILURE = '[projects] create external lab failure';
export const CreateExternalLabFailure = createAction(CREATE_EXTERNAL_LAB_FAILURE);

/******** UPDATE EXTERNAL LAB ***********/
const UPDATE_EXTERNAL_LAB_REQUEST = '[projects] update external lab request';
export const UpdateExternalLabRequest = createAction(UPDATE_EXTERNAL_LAB_REQUEST, props<any>());

const UPDATE_EXTERNAL_LAB_SUCCESS = '[projects] update external lab success';
export const UpdateExternalLabSuccess = createAction(UPDATE_EXTERNAL_LAB_SUCCESS, props<any>());

const UPDATE_EXTERNAL_LAB_FAILURE = '[projects] update external lab failure';
export const UpdateExternalLabFailure = createAction(UPDATE_EXTERNAL_LAB_FAILURE);

/******** DELETE EXTERNAL LAB LOOKUP ***********/
const DELETE_EXTERNAL_LAB_LOOKUP_REQUEST = '[projects] delete external lab lookup request';
export const DeleteExternalLabLookupRequest = createAction(DELETE_EXTERNAL_LAB_LOOKUP_REQUEST, props<any>());

const DELETE_EXTERNAL_LAB_LOOKUP_SUCCESS = '[projects] delete external lab lookup success';
export const DeleteExternalLabLookupSuccess = createAction(DELETE_EXTERNAL_LAB_LOOKUP_SUCCESS, props<any>());

const DELETE_EXTERNAL_LAB_LOOKUP_FAILURE = '[projects] delete external lab lookup failure';
export const DeleteExternalLabLookupFailure = createAction(DELETE_EXTERNAL_LAB_LOOKUP_FAILURE);

/******** FETCH MATERIAL TEST LAB LIST (EXTERNAL LABS) ***********/
const FETCH_MATERIAL_TEST_LAB_LIST_REQUEST = '[projects] fetch material test lab list request';
export const FetchMaterialTestLabListRequest = createAction(FETCH_MATERIAL_TEST_LAB_LIST_REQUEST, props<any>());

const FETCH_MATERIAL_TEST_LAB_LIST_SUCCESS = '[projects] fetch material test lab list success';
export const FetchMaterialTestLabListSuccess = createAction(FETCH_MATERIAL_TEST_LAB_LIST_SUCCESS, props<any>());

const FETCH_MATERIAL_TEST_LAB_LIST_FAILURE = '[projects] fetch material test lab list failure';
export const FetchMaterialTestLabListFailure = createAction(FETCH_MATERIAL_TEST_LAB_LIST_FAILURE);

/******** FETCH MATERIAL TEST NAME LIST ***********/
const FETCH_MATERIAL_TEST_NAME_LIST_REQUEST = '[projects] fetch material test name list request';
export const FetchMaterialTestNameListRequest = createAction(FETCH_MATERIAL_TEST_NAME_LIST_REQUEST, props<any>());

const FETCH_MATERIAL_TEST_NAME_LIST_SUCCESS = '[projects] fetch material test name list success';
export const FetchMaterialTestNameListSuccess = createAction(FETCH_MATERIAL_TEST_NAME_LIST_SUCCESS, props<any>());

const FETCH_MATERIAL_TEST_NAME_LIST_FAILURE = '[projects] fetch material test name list failure';
export const FetchMaterialTestNameListFailure = createAction(FETCH_MATERIAL_TEST_NAME_LIST_FAILURE);

/******** FETCH PROJECT MATERIAL TEST LIST ***********/
const FETCH_PROJECT_MATERIAL_TEST_LIST_REQUEST = '[projects] fetch project material test list request';
export const FetchProjectMaterialTestListRequest = createAction(
  FETCH_PROJECT_MATERIAL_TEST_LIST_REQUEST,
  props<any>()
);

const FETCH_PROJECT_MATERIAL_TEST_LIST_SUCCESS = '[projects] fetch project material test list success';
export const FetchProjectMaterialTestListSuccess = createAction(
  FETCH_PROJECT_MATERIAL_TEST_LIST_SUCCESS,
  props<any>()
);

const FETCH_PROJECT_MATERIAL_TEST_LIST_FAILURE = '[projects] fetch project material test list failure';
export const FetchProjectMaterialTestListFailure = createAction(
  FETCH_PROJECT_MATERIAL_TEST_LIST_FAILURE
);

/******** CREATE PROJECT MATERIAL TEST ***********/
const CREATE_PROJECT_MATERIAL_TEST_REQUEST = '[projects] create project material test request';
export const CreateProjectMaterialTestRequest = createAction(
  CREATE_PROJECT_MATERIAL_TEST_REQUEST,
  props<{ projectId: string; name: string }>()
);

const CREATE_PROJECT_MATERIAL_TEST_SUCCESS = '[projects] create project material test success';
export const CreateProjectMaterialTestSuccess = createAction(
  CREATE_PROJECT_MATERIAL_TEST_SUCCESS,
  props<{ projectId: string }>()
);

const CREATE_PROJECT_MATERIAL_TEST_FAILURE = '[projects] create project material test failure';
export const CreateProjectMaterialTestFailure = createAction(CREATE_PROJECT_MATERIAL_TEST_FAILURE);

/******** UPDATE PROJECT MATERIAL TEST ***********/
const UPDATE_PROJECT_MATERIAL_TEST_REQUEST = '[projects] update project material test request';
export const UpdateProjectMaterialTestRequest = createAction(
  UPDATE_PROJECT_MATERIAL_TEST_REQUEST,
  props<{ projectId: string; testId: string; name: string }>()
);

const UPDATE_PROJECT_MATERIAL_TEST_SUCCESS = '[projects] update project material test success';
export const UpdateProjectMaterialTestSuccess = createAction(
  UPDATE_PROJECT_MATERIAL_TEST_SUCCESS,
  props<{ projectId: string }>()
);

const UPDATE_PROJECT_MATERIAL_TEST_FAILURE = '[projects] update project material test failure';
export const UpdateProjectMaterialTestFailure = createAction(UPDATE_PROJECT_MATERIAL_TEST_FAILURE);

/******** DELETE PROJECT MATERIAL TEST ***********/
const DELETE_PROJECT_MATERIAL_TEST_REQUEST = '[projects] delete project material test request';
export const DeleteProjectMaterialTestRequest = createAction(
  DELETE_PROJECT_MATERIAL_TEST_REQUEST,
  props<{ projectId: string; testId: string }>()
);

const DELETE_PROJECT_MATERIAL_TEST_SUCCESS = '[projects] delete project material test success';
export const DeleteProjectMaterialTestSuccess = createAction(
  DELETE_PROJECT_MATERIAL_TEST_SUCCESS,
  props<{ projectId: string }>()
);

const DELETE_PROJECT_MATERIAL_TEST_FAILURE = '[projects] delete project material test failure';
export const DeleteProjectMaterialTestFailure = createAction(DELETE_PROJECT_MATERIAL_TEST_FAILURE);

/******** FETCH LAB NAME LIST ***********/
const FETCH_LAB_NAME_LIST_REQUEST = '[projects] fetch lab name list request';
export const FetchLabNameListRequest = createAction(FETCH_LAB_NAME_LIST_REQUEST, props<any>());

const FETCH_LAB_NAME_LIST_SUCCESS = '[projects] fetch lab name list success';
export const FetchLabNameListSuccess = createAction(FETCH_LAB_NAME_LIST_SUCCESS, props<any>());

const FETCH_LAB_NAME_LIST_FAILURE = '[projects] fetch lab name list failure';
export const FetchLabNameListFailure = createAction(FETCH_LAB_NAME_LIST_FAILURE);

/******** SAVE EXTERNAL TEST ***********/
const SAVE_EXTERNAL_TEST_REQUEST = '[projects] save external test request';
export const SaveExternalTestRequest = createAction(SAVE_EXTERNAL_TEST_REQUEST, props<any>());

const SAVE_EXTERNAL_TEST_SUCCESS = '[projects] save external test success';
export const SaveExternalTestSuccess = createAction(SAVE_EXTERNAL_TEST_SUCCESS, props<any>());

const SAVE_EXTERNAL_TEST_FAILURE = '[projects] save external test failure';
export const SaveExternalTestFailure = createAction(SAVE_EXTERNAL_TEST_FAILURE);

/******** SEND EXTERNAL TEST TO LAB ***********/
const SEND_EXTERNAL_TEST_TO_LAB_REQUEST = '[projects] send external test to lab request';
export const SendExternalTestToLabRequest = createAction(SEND_EXTERNAL_TEST_TO_LAB_REQUEST, props<any>());

const SEND_EXTERNAL_TEST_TO_LAB_SUCCESS = '[projects] send external test to lab success';
export const SendExternalTestToLabSuccess = createAction(SEND_EXTERNAL_TEST_TO_LAB_SUCCESS, props<any>());

const SEND_EXTERNAL_TEST_TO_LAB_FAILURE = '[projects] send external test to lab failure';
export const SendExternalTestToLabFailure = createAction(SEND_EXTERNAL_TEST_TO_LAB_FAILURE);

/******** ACCEPT EXTERNAL TEST LAB SCHEDULE ***********/
const ACCEPT_EXTERNAL_TEST_LAB_SCHEDULE_REQUEST = '[projects] accept external test lab schedule request';
export const AcceptExternalTestLabScheduleRequest = createAction(
  ACCEPT_EXTERNAL_TEST_LAB_SCHEDULE_REQUEST,
  props<any>()
);

const ACCEPT_EXTERNAL_TEST_LAB_SCHEDULE_SUCCESS = '[projects] accept external test lab schedule success';
export const AcceptExternalTestLabScheduleSuccess = createAction(
  ACCEPT_EXTERNAL_TEST_LAB_SCHEDULE_SUCCESS,
  props<any>()
);

const ACCEPT_EXTERNAL_TEST_LAB_SCHEDULE_FAILURE = '[projects] accept external test lab schedule failure';
export const AcceptExternalTestLabScheduleFailure = createAction(ACCEPT_EXTERNAL_TEST_LAB_SCHEDULE_FAILURE);

/******** RECORD EXTERNAL TEST LAB TEST DETAILS ***********/
const RECORD_EXTERNAL_TEST_LAB_TEST_DETAILS_REQUEST = '[projects] record external test lab test details request';
export const RecordExternalTestLabTestDetailsRequest = createAction(
  RECORD_EXTERNAL_TEST_LAB_TEST_DETAILS_REQUEST,
  props<any>()
);

const RECORD_EXTERNAL_TEST_LAB_TEST_DETAILS_SUCCESS = '[projects] record external test lab test details success';
export const RecordExternalTestLabTestDetailsSuccess = createAction(
  RECORD_EXTERNAL_TEST_LAB_TEST_DETAILS_SUCCESS,
  props<any>()
);

const RECORD_EXTERNAL_TEST_LAB_TEST_DETAILS_FAILURE = '[projects] record external test lab test details failure';
export const RecordExternalTestLabTestDetailsFailure = createAction(RECORD_EXTERNAL_TEST_LAB_TEST_DETAILS_FAILURE);

/******** UPDATE EXTERNAL TEST LAB TEST REPORT ***********/
const UPDATE_EXTERNAL_TEST_LAB_TEST_REPORT_REQUEST = '[projects] update external test lab test report request';
export const UpdateExternalTestLabTestReportRequest = createAction(
  UPDATE_EXTERNAL_TEST_LAB_TEST_REPORT_REQUEST,
  props<any>()
);

const UPDATE_EXTERNAL_TEST_LAB_TEST_REPORT_SUCCESS = '[projects] update external test lab test report success';
export const UpdateExternalTestLabTestReportSuccess = createAction(
  UPDATE_EXTERNAL_TEST_LAB_TEST_REPORT_SUCCESS,
  props<any>()
);

const UPDATE_EXTERNAL_TEST_LAB_TEST_REPORT_FAILURE = '[projects] update external test lab test report failure';
export const UpdateExternalTestLabTestReportFailure = createAction(UPDATE_EXTERNAL_TEST_LAB_TEST_REPORT_FAILURE);

/******** UPDATE EXTERNAL TEST LAB TEST RESULT ***********/
const UPDATE_EXTERNAL_TEST_LAB_TEST_RESULT_REQUEST = '[projects] update external test lab test result request';
export const UpdateExternalTestLabTestResultRequest = createAction(
  UPDATE_EXTERNAL_TEST_LAB_TEST_RESULT_REQUEST,
  props<any>()
);

const UPDATE_EXTERNAL_TEST_LAB_TEST_RESULT_SUCCESS = '[projects] update external test lab test result success';
export const UpdateExternalTestLabTestResultSuccess = createAction(
  UPDATE_EXTERNAL_TEST_LAB_TEST_RESULT_SUCCESS,
  props<any>()
);

const UPDATE_EXTERNAL_TEST_LAB_TEST_RESULT_FAILURE = '[projects] update external test lab test result failure';
export const UpdateExternalTestLabTestResultFailure = createAction(UPDATE_EXTERNAL_TEST_LAB_TEST_RESULT_FAILURE);

/******** CANCEL EXTERNAL TEST ***********/
const CANCEL_EXTERNAL_TEST_REQUEST = '[projects] cancel external test request';
export const CancelExternalTestRequest = createAction(CANCEL_EXTERNAL_TEST_REQUEST, props<any>());

const CANCEL_EXTERNAL_TEST_SUCCESS = '[projects] cancel external test success';
export const CancelExternalTestSuccess = createAction(CANCEL_EXTERNAL_TEST_SUCCESS, props<any>());

const CANCEL_EXTERNAL_TEST_FAILURE = '[projects] cancel external test failure';
export const CancelExternalTestFailure = createAction(CANCEL_EXTERNAL_TEST_FAILURE);

/******** FETCH BILLING SETTINGS ***********/
const FETCH_BILLING_SETTINGS_REQUEST = '[projects] fetch billing settings request';
export const FetchBillingSettingsRequest = createAction(FETCH_BILLING_SETTINGS_REQUEST, props<any>());

const FETCH_BILLING_SETTINGS_SUCCESS = '[projects] fetch billing settings success';
export const FetchBillingSettingsSuccess = createAction(FETCH_BILLING_SETTINGS_SUCCESS, props<any>());

const FETCH_BILLING_SETTINGS_FAILURE = '[projects] fetch billing settings failure';
export const FetchBillingSettingsFailure = createAction(FETCH_BILLING_SETTINGS_FAILURE, props<any>());

/******** UPDATE BILLING SETTINGS ***********/
const UPDATE_BILLING_SETTINGS_REQUEST = '[projects] update billing settings request';
export const UpdateBillingSettingsRequest = createAction(UPDATE_BILLING_SETTINGS_REQUEST, props<any>());

const UPDATE_BILLING_SETTINGS_SUCCESS = '[projects] update billing settings success';
export const UpdateBillingSettingsSuccess = createAction(UPDATE_BILLING_SETTINGS_SUCCESS, props<any>());

const UPDATE_BILLING_SETTINGS_FAILURE = '[projects] update billing settings failure';
export const UpdateBillingSettingsFailure = createAction(UPDATE_BILLING_SETTINGS_FAILURE, props<any>());

/******** FETCH PAYAPP SUMMARY ***********/
const FETCH_PAYAPP_SUMMARY_REQUEST = '[projects] fetch payapp summary request';
export const FetchPayAppSummaryRequest = createAction(FETCH_PAYAPP_SUMMARY_REQUEST, props<any>());

const FETCH_PAYAPP_SUMMARY_SUCCESS = '[projects] fetch payapp summary success';
export const FetchPayAppSummarySuccess = createAction(FETCH_PAYAPP_SUMMARY_SUCCESS, props<any>());

const FETCH_PAYAPP_SUMMARY_FAILURE = '[projects] fetch payapp summary failure';
export const FetchPayAppSummaryFailure = createAction(FETCH_PAYAPP_SUMMARY_FAILURE, props<any>());

/******** CLEAR BILLING SETTINGS ***********/
const CLEAR_BILLING_SETTINGS = '[projects] clear billing settings';
export const ClearBillingSettings = createAction(CLEAR_BILLING_SETTINGS);

/******** FETCH PROJECT CALENDAR ***********/
const FETCH_PROJECT_CALENDAR_REQUEST = '[projects] fetch project calendar request';
export const FetchProjectCalendarRequest = createAction(FETCH_PROJECT_CALENDAR_REQUEST, props<{ payload: { projectId: string } }>());

const FETCH_PROJECT_CALENDAR_SUCCESS = '[projects] fetch project calendar success';
export const FetchProjectCalendarSuccess = createAction(FETCH_PROJECT_CALENDAR_SUCCESS, props<{ calendar: ProjectCalendar }>());

const FETCH_PROJECT_CALENDAR_FAILURE = '[projects] fetch project calendar failure';
export const FetchProjectCalendarFailure = createAction(FETCH_PROJECT_CALENDAR_FAILURE, props<{ error: any }>());

/******** UPDATE PROJECT CALENDAR ***********/
const UPDATE_PROJECT_CALENDAR_REQUEST = '[projects] update project calendar request';
export const UpdateProjectCalendarRequest = createAction(UPDATE_PROJECT_CALENDAR_REQUEST, props<{ payload: { projectId: string; calendars: any } }>());

const UPDATE_PROJECT_CALENDAR_SUCCESS = '[projects] update project calendar success';
export const UpdateProjectCalendarSuccess = createAction(UPDATE_PROJECT_CALENDAR_SUCCESS, props<{ calendar: ProjectCalendar }>());

const UPDATE_PROJECT_CALENDAR_FAILURE = '[projects] update project calendar failure';
export const UpdateProjectCalendarFailure = createAction(UPDATE_PROJECT_CALENDAR_FAILURE, props<{ error: any }>());

/******** INITIALIZE PROJECT CALENDAR ***********/
const INITIALIZE_PROJECT_CALENDAR_REQUEST = '[projects] initialize project calendar request';
export const InitializeProjectCalendarRequest = createAction(INITIALIZE_PROJECT_CALENDAR_REQUEST, props<{ payload: { projectId: string } }>());

const INITIALIZE_PROJECT_CALENDAR_SUCCESS = '[projects] initialize project calendar success';
export const InitializeProjectCalendarSuccess = createAction(INITIALIZE_PROJECT_CALENDAR_SUCCESS, props<{ calendar: ProjectCalendar }>());

const INITIALIZE_PROJECT_CALENDAR_FAILURE = '[projects] initialize project calendar failure';
export const InitializeProjectCalendarFailure = createAction(INITIALIZE_PROJECT_CALENDAR_FAILURE, props<{ error: any }>());

/******** FETCH PAYAPP TEMPLATES ***********/
const FETCH_PAYAPP_TEMPLATES_REQUEST = '[projects] fetch payapp templates request';
export const FetchPayAppTemplatesRequest = createAction(FETCH_PAYAPP_TEMPLATES_REQUEST, props<{ organizationId?: string; projectId?: string }>());

const FETCH_PAYAPP_TEMPLATES_SUCCESS = '[projects] fetch payapp templates success';
export const FetchPayAppTemplatesSuccess = createAction(FETCH_PAYAPP_TEMPLATES_SUCCESS, props<{ templates: any[] }>());

const FETCH_PAYAPP_TEMPLATES_FAILURE = '[projects] fetch payapp templates failure';
export const FetchPayAppTemplatesFailure = createAction(FETCH_PAYAPP_TEMPLATES_FAILURE, props<{ error: any }>());

/******** CREATE PAYAPP TEMPLATE ***********/
const CREATE_PAYAPP_TEMPLATE_REQUEST = '[projects] create payapp template request';
export const CreatePayAppTemplateRequest = createAction(CREATE_PAYAPP_TEMPLATE_REQUEST, props<{ organizationId?: string; projectId?: string; template: any }>());

const CREATE_PAYAPP_TEMPLATE_SUCCESS = '[projects] create payapp template success';
export const CreatePayAppTemplateSuccess = createAction(CREATE_PAYAPP_TEMPLATE_SUCCESS, props<{ template: any }>());

const CREATE_PAYAPP_TEMPLATE_FAILURE = '[projects] create payapp template failure';
export const CreatePayAppTemplateFailure = createAction(CREATE_PAYAPP_TEMPLATE_FAILURE, props<{ error: any }>());

/******** UPDATE PAYAPP TEMPLATE ***********/
const UPDATE_PAYAPP_TEMPLATE_REQUEST = '[projects] update payapp template request';
export const UpdatePayAppTemplateRequest = createAction(UPDATE_PAYAPP_TEMPLATE_REQUEST, props<{ organizationId?: string; projectId?: string; templateId: string; template: any }>());

const UPDATE_PAYAPP_TEMPLATE_SUCCESS = '[projects] update payapp template success';
export const UpdatePayAppTemplateSuccess = createAction(UPDATE_PAYAPP_TEMPLATE_SUCCESS, props<{ template: any }>());

const UPDATE_PAYAPP_TEMPLATE_FAILURE = '[projects] update payapp template failure';
export const UpdatePayAppTemplateFailure = createAction(UPDATE_PAYAPP_TEMPLATE_FAILURE, props<{ error: any }>());

/******** DELETE PAYAPP TEMPLATE ***********/
const DELETE_PAYAPP_TEMPLATE_REQUEST = '[projects] delete payapp template request';
export const DeletePayAppTemplateRequest = createAction(DELETE_PAYAPP_TEMPLATE_REQUEST, props<{ organizationId: string; templateId: string }>());

const DELETE_PAYAPP_TEMPLATE_SUCCESS = '[projects] delete payapp template success';
export const DeletePayAppTemplateSuccess = createAction(DELETE_PAYAPP_TEMPLATE_SUCCESS, props<{ templateId: string }>());

const DELETE_PAYAPP_TEMPLATE_FAILURE = '[projects] delete payapp template failure';
export const DeletePayAppTemplateFailure = createAction(DELETE_PAYAPP_TEMPLATE_FAILURE, props<{ error: any }>());

/******** PREVIEW PAYAPP TEMPLATE ***********/
const PREVIEW_PAYAPP_TEMPLATE_REQUEST = '[projects] preview payapp template request';
export const PreviewPayAppTemplateRequest = createAction(PREVIEW_PAYAPP_TEMPLATE_REQUEST, props<{ templateId: string; payAppId?: string }>());

const PREVIEW_PAYAPP_TEMPLATE_SUCCESS = '[projects] preview payapp template success';
export const PreviewPayAppTemplateSuccess = createAction(PREVIEW_PAYAPP_TEMPLATE_SUCCESS, props<{ previewUrl: string }>());

const PREVIEW_PAYAPP_TEMPLATE_FAILURE = '[projects] preview payapp template failure';
export const PreviewPayAppTemplateFailure = createAction(PREVIEW_PAYAPP_TEMPLATE_FAILURE, props<{ error: any }>());

/******** CLEAR PAYAPP TEMPLATES ***********/
const CLEAR_PAYAPP_TEMPLATES = '[projects] clear payapp templates';
export const ClearPayAppTemplates = createAction(CLEAR_PAYAPP_TEMPLATES);

/******** CHECK EMAIL EXISTS ***********/
const CHECK_EMAIL_EXISTS_REQUEST = '[projects] check email exists request';
export const CheckEmailExistsRequest = createAction(CHECK_EMAIL_EXISTS_REQUEST, props<any>());

const CHECK_EMAIL_EXISTS_SUCCESS = '[projects] check email exists success';
export const CheckEmailExistsSuccess = createAction(CHECK_EMAIL_EXISTS_SUCCESS, props<any>());

const CHECK_EMAIL_EXISTS_FAILURE = '[projects] check email exists failure';
export const CheckEmailExistsFailure = createAction(CHECK_EMAIL_EXISTS_FAILURE, props<any>());

/******** CHECK PHONE EXISTS ***********/
const CHECK_PHONE_EXISTS_REQUEST = '[projects] check phone exists request';
export const CheckPhoneExistsRequest = createAction(CHECK_PHONE_EXISTS_REQUEST, props<any>());

const CHECK_PHONE_EXISTS_SUCCESS = '[projects] check phone exists success';
export const CheckPhoneExistsSuccess = createAction(CHECK_PHONE_EXISTS_SUCCESS, props<any>());

const CHECK_PHONE_EXISTS_FAILURE = '[projects] check phone exists failure';
export const CheckPhoneExistsFailure = createAction(CHECK_PHONE_EXISTS_FAILURE, props<any>());

/******** CLEAR EMAIL EXISTS CHECK ***********/
const CLEAR_EMAIL_EXISTS_CHECK = '[projects] clear email exists check';
export const ClearEmailExistsCheck = createAction(CLEAR_EMAIL_EXISTS_CHECK);

/******** CLEAR PHONE EXISTS CHECK ***********/
const CLEAR_PHONE_EXISTS_CHECK = '[projects] clear phone exists check';
export const ClearPhoneExistsCheck = createAction(CLEAR_PHONE_EXISTS_CHECK);

/******** DELETE SUBMITTALS ITEM ***********/
const DELETE_SUBMITTALS_ITEM_REQUEST = '[projects] delete submittals item request';
export const DeleteSubmittalsItemRequest = createAction(DELETE_SUBMITTALS_ITEM_REQUEST, props<any>());

const DELETE_SUBMITTALS_ITEM_SUCCESS = '[projects] delete submittals item success';
export const DeleteSubmittalsItemSuccess = createAction(DELETE_SUBMITTALS_ITEM_SUCCESS, props<any>());

const DELETE_SUBMITTALS_ITEM_FAILURE = '[projects] delete submittals item failure';
export const DeleteSubmittalsItemFailure = createAction(DELETE_SUBMITTALS_ITEM_FAILURE);

/******** CREATE CHANGE ORDER FROM REQUESTS ***********/
const CREATE_CHANGE_ORDER_FROM_REQUESTS_REQUEST = '[Projects] Create Change Order From Requests Request';
export const CreateChangeOrderFromRequestsRequest = createAction(
  CREATE_CHANGE_ORDER_FROM_REQUESTS_REQUEST,
  props<{ payload: any }>()
);

const CREATE_CHANGE_ORDER_FROM_REQUESTS_SUCCESS = '[Projects] Create Change Order From Requests Success';
export const CreateChangeOrderFromRequestsSuccess = createAction(
  CREATE_CHANGE_ORDER_FROM_REQUESTS_SUCCESS,
  props<{ data: any }>()
);

const CREATE_CHANGE_ORDER_FROM_REQUESTS_FAILURE = '[Projects] Create Change Order From Requests Failure';
export const CreateChangeOrderFromRequestsFailure = createAction(CREATE_CHANGE_ORDER_FROM_REQUESTS_FAILURE);

/******** FETCH AVAILABLE CORS ***********/
const FETCH_AVAILABLE_CORS_REQUEST = '[Projects] Fetch Available CORs Request';
export const FetchAvailableCorsRequest = createAction(
  FETCH_AVAILABLE_CORS_REQUEST,
  props<{ payload: any }>()
);

const FETCH_AVAILABLE_CORS_SUCCESS = '[Projects] Fetch Available CORs Success';
export const FetchAvailableCorsSuccess = createAction(
  FETCH_AVAILABLE_CORS_SUCCESS,
  props<{ data: any }>()
);

const FETCH_AVAILABLE_CORS_FAILURE = '[Projects] Fetch Available CORs Failure';
export const FetchAvailableCorsFailure = createAction(FETCH_AVAILABLE_CORS_FAILURE);

/******** LINK REQUESTS TO CHANGE ORDER ***********/
const LINK_REQUESTS_TO_CHANGE_ORDER_REQUEST = '[Projects] Link Requests To Change Order Request';
export const LinkRequestsToChangeOrderRequest = createAction(
  LINK_REQUESTS_TO_CHANGE_ORDER_REQUEST,
  props<{ payload: any }>()
);

const LINK_REQUESTS_TO_CHANGE_ORDER_SUCCESS = '[Projects] Link Requests To Change Order Success';
export const LinkRequestsToChangeOrderSuccess = createAction(
  LINK_REQUESTS_TO_CHANGE_ORDER_SUCCESS,
  props<{ data: any }>()
);

const LINK_REQUESTS_TO_CHANGE_ORDER_FAILURE = '[Projects] Link Requests To Change Order Failure';
export const LinkRequestsToChangeOrderFailure = createAction(LINK_REQUESTS_TO_CHANGE_ORDER_FAILURE);

/******** UNLINK REQUEST FROM CHANGE ORDER ***********/
const UNLINK_REQUEST_FROM_CHANGE_ORDER_REQUEST = '[Projects] Unlink Request From Change Order Request';
export const UnlinkRequestFromChangeOrderRequest = createAction(
  UNLINK_REQUEST_FROM_CHANGE_ORDER_REQUEST,
  props<{ payload: any }>()
);

const UNLINK_REQUEST_FROM_CHANGE_ORDER_SUCCESS = '[Projects] Unlink Request From Change Order Success';
export const UnlinkRequestFromChangeOrderSuccess = createAction(
  UNLINK_REQUEST_FROM_CHANGE_ORDER_SUCCESS,
  props<{ data: any }>()
);

const UNLINK_REQUEST_FROM_CHANGE_ORDER_FAILURE = '[Projects] Unlink Request From Change Order Failure';
export const UnlinkRequestFromChangeOrderFailure = createAction(UNLINK_REQUEST_FROM_CHANGE_ORDER_FAILURE);

/******** SCAN BATCH TICKET ***********/
const SCAN_BATCH_TICKET_REQUEST = '[projects] scan batch ticket request';
export const ScanBatchTicketRequest = createAction(SCAN_BATCH_TICKET_REQUEST, props<{ payload: { file: File } }>());

const SCAN_BATCH_TICKET_SUCCESS = '[projects] scan batch ticket success';
export const ScanBatchTicketSuccess = createAction(SCAN_BATCH_TICKET_SUCCESS, props<{ data: any }>());

const SCAN_BATCH_TICKET_FAILURE = '[projects] scan batch ticket failure';
export const ScanBatchTicketFailure = createAction(SCAN_BATCH_TICKET_FAILURE);

const CLEAR_BATCH_TICKET_DATA = '[projects] clear batch ticket data';
export const ClearBatchTicketData = createAction(CLEAR_BATCH_TICKET_DATA);

/******** WARRANTY ***********/
const FETCH_WARRANTIES_REQUEST = '[Warranty] Fetch Warranties Request';
const FETCH_WARRANTIES_SUCCESS = '[Warranty] Fetch Warranties Success';
const FETCH_WARRANTIES_FAILURE = '[Warranty] Fetch Warranties Failure';
const CREATE_WARRANTY_REQUEST = '[Warranty] Create Warranty Request';
const CREATE_WARRANTY_SUCCESS = '[Warranty] Create Warranty Success';
const CREATE_WARRANTY_FAILURE = '[Warranty] Create Warranty Failure';
const UPDATE_WARRANTY_REQUEST = '[Warranty] Update Warranty Request';
const UPDATE_WARRANTY_SUCCESS = '[Warranty] Update Warranty Success';
const UPDATE_WARRANTY_FAILURE = '[Warranty] Update Warranty Failure';
const DELETE_WARRANTY_REQUEST = '[Warranty] Delete Warranty Request';
const DELETE_WARRANTY_SUCCESS = '[Warranty] Delete Warranty Success';
const DELETE_WARRANTY_FAILURE = '[Warranty] Delete Warranty Failure';
const FETCH_WARRANTY_CLAIMS_REQUEST = '[Warranty] Fetch Claims Request';
const FETCH_WARRANTY_CLAIMS_SUCCESS = '[Warranty] Fetch Claims Success';
const FETCH_WARRANTY_CLAIMS_FAILURE = '[Warranty] Fetch Claims Failure';
const CREATE_WARRANTY_CLAIM_REQUEST = '[Warranty] Create Claim Request';
const CREATE_WARRANTY_CLAIM_SUCCESS = '[Warranty] Create Claim Success';
const CREATE_WARRANTY_CLAIM_FAILURE = '[Warranty] Create Claim Failure';
const FETCH_WARRANTY_CLAIM_DETAIL_REQUEST = '[Warranty] Fetch Claim Detail Request';
const FETCH_WARRANTY_CLAIM_DETAIL_SUCCESS = '[Warranty] Fetch Claim Detail Success';
const FETCH_WARRANTY_CLAIM_DETAIL_FAILURE = '[Warranty] Fetch Claim Detail Failure';
const WARRANTY_CLAIM_ACTION_REQUEST = '[Warranty] Claim Action Request';
const WARRANTY_CLAIM_ACTION_SUCCESS = '[Warranty] Claim Action Success';
const WARRANTY_CLAIM_ACTION_FAILURE = '[Warranty] Claim Action Failure';

export const FetchWarrantiesRequest = createAction(FETCH_WARRANTIES_REQUEST, props<any>());
export const FetchWarrantiesSuccess = createAction(FETCH_WARRANTIES_SUCCESS, props<any>());
export const FetchWarrantiesFailure = createAction(FETCH_WARRANTIES_FAILURE);
export const CreateWarrantyRequest = createAction(CREATE_WARRANTY_REQUEST, props<any>());
export const CreateWarrantySuccess = createAction(CREATE_WARRANTY_SUCCESS, props<any>());
export const CreateWarrantyFailure = createAction(CREATE_WARRANTY_FAILURE);
export const UpdateWarrantyRequest = createAction(UPDATE_WARRANTY_REQUEST, props<any>());
export const UpdateWarrantySuccess = createAction(UPDATE_WARRANTY_SUCCESS, props<any>());
export const UpdateWarrantyFailure = createAction(UPDATE_WARRANTY_FAILURE);
export const DeleteWarrantyRequest = createAction(DELETE_WARRANTY_REQUEST, props<any>());
export const DeleteWarrantySuccess = createAction(DELETE_WARRANTY_SUCCESS, props<any>());
export const DeleteWarrantyFailure = createAction(DELETE_WARRANTY_FAILURE);
export const FetchWarrantyClaimsRequest = createAction(FETCH_WARRANTY_CLAIMS_REQUEST, props<any>());
export const FetchWarrantyClaimsSuccess = createAction(FETCH_WARRANTY_CLAIMS_SUCCESS, props<any>());
export const FetchWarrantyClaimsFailure = createAction(FETCH_WARRANTY_CLAIMS_FAILURE);
export const CreateWarrantyClaimRequest = createAction(CREATE_WARRANTY_CLAIM_REQUEST, props<any>());
export const CreateWarrantyClaimSuccess = createAction(CREATE_WARRANTY_CLAIM_SUCCESS, props<any>());
export const CreateWarrantyClaimFailure = createAction(CREATE_WARRANTY_CLAIM_FAILURE);
export const FetchWarrantyClaimDetailRequest = createAction(FETCH_WARRANTY_CLAIM_DETAIL_REQUEST, props<any>());
export const FetchWarrantyClaimDetailSuccess = createAction(FETCH_WARRANTY_CLAIM_DETAIL_SUCCESS, props<any>());
export const FetchWarrantyClaimDetailFailure = createAction(FETCH_WARRANTY_CLAIM_DETAIL_FAILURE);
export const WarrantyClaimActionRequest = createAction(WARRANTY_CLAIM_ACTION_REQUEST, props<any>());
export const WarrantyClaimActionSuccess = createAction(WARRANTY_CLAIM_ACTION_SUCCESS, props<any>());
export const WarrantyClaimActionFailure = createAction(WARRANTY_CLAIM_ACTION_FAILURE);
